/* eslint-disable react/no-unescaped-entities */
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PrivacyPolicyq = () => {
    return (
        <div className="container my-4">
            <div className="p-4 bg-light shadow rounded">
                <h1 className="h2 fw-bold mb-4" style={{ color: "#00213e" }}>
                    Second Opinion USA LLC (SecOpp) PRIVACY POLICY
                </h1>
                <p className="mb-2">Version: 1.0</p>
                <p className="mb-2">Effective Date: February 1, 2025</p>
                <p className="mb-2">Last Updated: January 31, 2025</p>
                <h2 className="h4 fw-bold mt-5 mb-4">TABLE OF CONTENTS</h2>
                <ul className="list-unstyled mb-4">
                    <li>1. Introduction</li>
                    <li>2. Definitions</li>
                    <li>3. Data Collection</li>
                    <li>4. Data Usage</li>
                    <li>5. Data Sharing and Disclosures</li>
                    <li>6. Data Storage and Security</li>
                    <li>7. User Rights and Choices</li>
                    <li>8. Consent Management</li>
                    <li>9. Cookies and Tracking Technologies</li>
                    <li>10. Special Provisions for Healthcare Data</li>
                    <li>11. Communications</li>
                    <li>12. Children’s Privacy</li>
                    <li>13. Updates to Privacy Policy</li>
                    <li>14. Contact Information</li>
                    <li>15. Jurisdiction-Specific Addenda</li>
                </ul>
                <h2 className="h4 fw-bold mt-5 mb-4">1. INTRODUCTION</h2>
                <h3 className="h5 fw-bold mb-2"> 1. Purpose of the Policy</h3>
                <p className="mb-4">
                    This Privacy Policy (“Policy”) describes how Second Opinion
                    USA LLC (“SecOpp,” “we,” “our,” or “us”), a telemedicine
                    platform connecting U.S. physicians with patients in India,
                    collects, uses, maintains, protects, and discloses your
                    personal information and protected health information. This
                    Policy applies to all information collected through our
                    website (www.secopp.com), mobile application, and any
                    related services, sales, marketing, or events (collectively,
                    the “Platform”).
                </p>
                <h3 className="h5 fw-bold mb-2">
                    1.2 Our Commitment to Privacy
                </h3>
                <p className="mb-4">
                    At SecOpp, we are deeply committed to protecting your
                    privacy and the security of your personal and health
                    information. We understand the sensitive nature of health
                    data and take our responsibility as custodians of this
                    information seriously. Our commitment extends to compliance
                    with all applicable laws and regulations in the
                    jurisdictions where we operate, particularly focusing on
                    U.S. and Indian legal frameworks.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    1.3 General Approach to Data Protection and Compliance
                </h3>
                <p className="mb-4">
                    We implement a comprehensive, multi-layered approach to data
                    protection that includes:
                </p>
                <ul className="list-unstyled mb-4">
                    <p className="mb-4">
                        <strong>Technical Safeguards:</strong> Advanced
                        encryption, secure servers, and regular security audits
                    </p>

                    <p className="mb-4">
                        <strong>Administrative Controls:</strong> Staff
                        training, access limitations, and comprehensive data
                        handling policies
                    </p>
                    <p className="mb-4">
                        <strong>Physical Security:</strong> Secure facilities
                        for any physical records and hardware containing
                        personal data
                    </p>
                    <p className="mb-4">
                        <strong>Compliance Programs:</strong> Ongoing adherence
                        to healthcare privacy standards including HIPAA, HITECH,
                        GDPR (where applicable), and CCPA/CPRA (for California
                        residents)
                    </p>
                    <p className="mb-4">
                        <strong>Risk Assessment: </strong> Regular evaluation of
                        potential vulnerabilities and implementation of
                        preventive measures
                    </p>
                </ul>
                <h1 className="mb-3">
                    BY ACCESSING OR USING OUR PLATFORM, YOU AGREE TO THIS
                    PRIVACY POLICY. IF YOU DO NOT AGREE WITH ANY PART OF THIS
                    POLICY, PLEASE DO NOT USE OUR SERVICES.
                </h1>
                <h2 className="h4 fw-bold mt-5 mb-4">2. DEFINITIONS</h2>
                <p className="mb-4">
                    To ensure clarity throughout this Policy, the following
                    terms are defined as:
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.1 Personal and Healthcare-Related Terms
                </h3>
                <p className="mb-4">
                    <strong>Personal Data/Personal Information: </strong>Any
                    information relating to an identified or identifiable
                    natural person (“data subject”). This includes, but is not
                    limited to, name, identification number, location data,
                    online identifier, or factors specific to the physical,
                    physiological, genetic, mental, economic, cultural, or
                    social identity of that person.
                </p>
                <p className="mb-4">
                    <strong>Protected Health Information (PHI): </strong> Any
                    individually identifiable health information transmitted or
                    maintained in any form or medium that relates to: (i) the
                    past, present, or future physical or mental health or
                    condition of an individual; (ii) the provision of healthcare
                    to an individual; or (iii) the past, present, or future
                    payment for the provision of healthcare to an individual, as
                    defined under HIPAA.
                </p>
                <p className="mb-4">
                    <strong>Sensitive Personal Information: </strong> A subset
                    of personal information that includes health information,
                    biometric data, precise geolocation, racial or ethnic
                    origin, religious beliefs, and other categories defined by
                    applicable law as requiring special protection.
                </p>
                <p className="mb-4">
                    <strong>De-identified Information: </strong> Information
                    that has been processed to remove or obscure all direct and
                    indirect identifiers such that the information cannot
                    reasonably identify, relate to, describe, or be capable of
                    being associated with a particular individual.
                </p>
                <h3 className="h5 fw-bold mb-2">2.2 Role-Based Terms</h3>
                <p className="mb-4">
                    <strong>Data Controller:</strong>The entity (Second Opinion
                    USA LLC) that determines the purposes and means of
                    processing personal data.
                </p>
                <p className="mb-4">
                    <strong>Data Processor: </strong>A third party that
                    processes personal data on behalf of Second Opinion USA LLC.
                </p>
                <p className="mb-4">
                    <strong>Covered Entity: </strong>A healthcare provider,
                    health plan, or healthcare clearinghouse that transmits
                    health information electronically in connection with certain
                    HIPAA-defined transactions.
                </p>
                <p className="mb-4">
                    <strong>Business Associate:</strong>A person or entity that
                    performs certain functions or activities involving the use
                    or disclosure of PHI on behalf of, or provides services to,
                    a Covered Entity.
                </p>
                <p className="mb-4">
                    <strong>User/Patient:</strong>Any individual who uses our
                    Platform to access telemedicine services.
                </p>
                <p className="mb-4">
                    <strong>Provider:</strong>Any healthcare professional,
                    including physicians, specialists, and allied health
                    professionals, who provides healthcare services through our
                    Platform.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.1 Personal and Healthcare-Related Terms
                </h3>
                <p className="mb-4">
                    <strong>Personal Data/Personal Information: </strong>Any
                    information relating to an identified or identifiable
                    natural person (“data subject”). This includes, but is not
                    limited to, name, identification number, location data,
                    online identifier, or factors specific to the physical,
                    physiological, genetic, mental, economic, cultural, or
                    social identity of that person.
                </p>
                <p className="mb-4">
                    <strong>Protected Health Information (PHI): </strong> Any
                    individually identifiable health information transmitted or
                    maintained in any form or medium that relates to: (i) the
                    past, present, or future physical or mental health or
                    condition of an individual; (ii) the provision of healthcare
                    to an individual; or (iii) the past, present, or future
                    payment for the provision of healthcare to an individual, as
                    defined under HIPAA.
                </p>
                <p className="mb-4">
                    <strong>Sensitive Personal Information: </strong> A subset
                    of personal information that includes health information,
                    biometric data, precise geolocation, racial or ethnic
                    origin, religious beliefs, and other categories defined by
                    applicable law as requiring special protection.
                </p>
                <p className="mb-4">
                    <strong>De-identified Information: </strong> Information
                    that has been processed to remove or obscure all direct and
                    indirect identifiers such that the information cannot
                    reasonably identify, relate to, describe, or be capable of
                    being associated with a particular individual.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.3 Technical and Legal Terms
                </h3>
                <p className="mb-4">
                    <strong>Processing:</strong>Any operation performed on
                    personal data, whether or not by automated means, such as
                    collection, recording, organization, structuring, storage,
                    adaptation, retrieval, consultation, use, disclosure,
                    dissemination, restriction, erasure, or destruction.
                </p>
                <p className="mb-4">
                    <strong>Consent: </strong>Freely given, specific, informed,
                    and unambiguous indication of a data subject’s wishes by
                    which they signify agreement to the processing of their
                    personal data.
                </p>
                <p className="mb-4">
                    <strong>Data Breach: </strong>A security incident leading to
                    the accidental or unlawful destruction, loss, alteration,
                    unauthorized disclosure of, or access to, personal data or
                    PHI.
                </p>
                <p className="mb-4">
                    <strong>Cross-Border Transfer:</strong>The movement of
                    personal data from one country or jurisdiction to another,
                    particularly relevant for our operations between the U.S.
                    and India.
                </p>
                <p className="mb-4">
                    <strong>DATA COLLECTION</strong>
                </p>
                <h6>Types of Data Collected</h6>
                <h6>Personal Information</h6>{" "}
                <p>
                    We collect personal information that you voluntarily provide
                    to us when you register on the Platform, express interest in
                    obtaining information about our services, or otherwise
                    contact us. This personal information may include, but is
                    not limited to:
                </p>
                <li>1. Full name</li>
                <li>2. Date of birth</li>
                <li>3. Gender</li>
                <li>4. Email address</li>
                <li>5. Mailing address</li>
                <li>6. Phone number</li>
                <li>
                    7. Government-issued identification numbers (for identity
                    verification)
                </li>
                <li>
                    8. Payment information (credit card numbers, banking
                    details)
                </li>
                <li>9. Profile pictures</li>
                <li>10. Authentication credentials (usernames, passwords)</li>
                <li>11. Electronic signatures</li>
                <li>12. Communication preferences</li>
                {/* 3.31 */}
                <h3 className="h5 fw-bold mb-2">3.1.2 Health Data</h3>
                <p>
                    In the course of providing telemedicine services, we collect
                    health-related information, including:
                </p>
                <li>Medical history and conditions</li>
                <li>Current symptoms and concerns</li>
                <li>Allergies and adverse reactions</li>
                <li>Medications and supplements</li>
                <li>Previous treatments and procedures</li>
                <li>Test results and diagnostic information</li>
                <li>Family medical history</li>
                <li>
                    Lifestyle information (smoking status, alcohol consumption,
                    exercise habits)
                </li>
                <li>Insurance details and billing information</li>
                <li>Treatment plans and recommendations</li>
                <li>Healthcare provider notes and assessments</li>
                <li>Images or videos submitted for diagnostic purposes</li>
                <li>
                    Monitoring data from connected medical devices (if
                    applicable)
                </li>
                <h3 className="h5 fw-bold mb-2">3.1.3 Technical Data</h3>
                <p>
                    Our Platform automatically collects certain information when
                    you visit, use, or navigate it. This information does not
                    reveal your specific identity but may include:
                </p>
                <li>IP address</li>
                <li>Device and browser information</li>
                <li>Operating system</li>
                <li>Geographic location (country and city level)</li>
                <li>Time zone</li>
                <li>Referring website</li>
                <li>Pages visited and features used</li>
                <li>Clickstream data and browsing patterns</li>
                <li>System activity and hardware settings</li>
                <li>Session duration and timing</li>
                <li>Network connection information</li>
                <li>Platform performance metrics</li>
                <li>Error logs and crash analytics</li>
                <h3 className="h5 fw-bold mb-2">3.2 How Data Is Collected</h3>
                <li>Direct Collection</li>
                <p>Information you provide directly to us through:</p>
                <li>Account registration and profile creation</li>
                <li>Intake forms and medical questionnaires</li>
                <li>Telemedicine consultation sessions</li>
                <li>Customer support interactions</li>
                <li>Surveys and feedback forms</li>
                <li>User-generated content (questions, comments)</li>
                <li>Correspondence (email, chat, phone)</li>
                <li>Payment processing</li>
                <h3 className="h5 fw-bold mb-2">3.2.2 Automated Collection</h3>
                <p>Information collected automatically through:</p>
                <li>Cookies and similar tracking technologies</li>
                <li>Server logs and analytics tools</li>
                <li>Mobile device identifiers</li>
                <li>Application programming interfaces (APIs)</li>
                <li>Web beacons and pixel tags</li>
                <li>Local storage objects</li>
                <li>Session replay tools</li>
                <li>Network monitoring software</li>
                <h3 className="h3 fw-bold mb-2">3.2.3 Third-Party Sources</h3>
                <p>Information we may receive from other sources:</p>
                <li>Electronic health record (EHR) systems</li>
                <li>Health insurance providers</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                <li>Healthcare providers and medical professionals</li>
                {/* cgat gpt command check */}
                <h3 className="h3 fw-bold mb-2">
                    3.3 Legal Basis for Collection
                </h3>
                <li>United States</li>
                <p>
                    Under U.S. law, including HIPAA, we collect and process data
                    based on:
                </p>
                <li>Provision of healthcare services (treatment)</li>
                <li>Processing payments and managing billing</li>
                <li>Healthcare operations and administrative functions</li>
                <li>Compliance with legal and regulatory obligations</li>
                <li>Your explicit consent where required by law</li>
                <h3 className="h3 fw-bold mb-2">
                    3.3.2 For Users in the European Union
                </h3>
                <p>Under GDPR (where applicable), we process data based on:</p>
                <li>Your explicit consent</li>
                <li>Performance of a contract (service agreement)</li>
                <li>Compliance with legal obligations</li>
                <li>Protection of vital interests in emergency situations</li>
                <li>
                    Legitimate interests, where not overridden by your
                    fundamental rights
                </li>
                <h3 className="h3 fw-bold mb-2">
                    3.3.3 For California Residents
                </h3>
                <p>Under CCPA/CPRA, we collect and process data based on:</p>
                <li>Your consent</li>
                <li>Necessity to provide requested services</li>
                <li>Compliance with legal obligations</li>
                <li>Other purposes disclosed at the time of collection</li>
                <h3 className="h3 fw-bold mb-2">
                    3.3.4 Special Considerations for Sensitive Health
                    Information
                </h3>
                <p>
                    We take additional precautions when processing PHI and
                    sensitive health information:
                </p>
                <li>
                    We obtain specific consent for processing sensitive health
                    data
                </li>
                <li>
                    We limit access to authorized personnel on a need-to-know
                    basis
                </li>
                <li>
                    We implement enhanced security measures for sensitive data
                </li>
                <li>
                    We only use such data for treatment, payment, healthcare
                    operations, or as otherwise permitted by law or with your
                    consent
                </li>
                <li>DATA USAGE</li>
                <li>Primary Purposes for Data Usage</li>
                <li>Service Delivery</li>
                <p>We use your personal and health information to:</p>
                <li>Establish and maintain your user account</li>
                <li>Authenticate your identity for secure access</li>
                <li>Connect you with appropriate healthcare providers</li>
                <li>Facilitate telemedicine consultations and follow-ups</li>
                <li>Manage appointments and scheduling</li>
                <li>
                    Process and transmit prescriptions (where legally permitted)
                </li>
                <li>Monitor health conditions and treatment progress</li>
                <li>Provide personalized health recommendations</li>
                <li>
                    Coordinate care between multiple providers (if applicable)
                </li>
                <li>Generate and maintain medical records</li>
                <li>
                    Enable communication between you and your healthcare
                    providers
                </li>
                <h3 className="h3 fw-bold mb-2">4.1.2 Internal Processing</h3>
                <p>
                    We use your information for operational purposes, including:
                </p>
                <li>Processing payments and managing billing</li>
                <li>Verifying insurance coverage and eligibility</li>
                <li>Conducting clinical reviews and quality assurance</li>
                <li>
                    Resolving technical issues and customer support inquiries
                </li>
                <li>Analyzing service utilization and health outcomes</li>
                <li>Improving clinical workflows and processes</li>
                <li>Training our staff and healthcare providers</li>
                <li>Managing and optimizing Platform performance</li>
                <li>Developing and testing new features</li>
                <li>Maintaining accurate records and documentation</li>
                <h3 className="h3 fw-bold mb-2">
                    Secondary Purposes for Data Usage
                </h3>
                <li>Research and Analytics</li>
                <p>
                    With appropriate safeguards and consent where required, we
                    may use data for:
                </p>
                <li>Conducting clinical research and studies</li>
                <li>Analyzing healthcare trends and patterns</li>
                <li>Evaluating treatment efficacy and outcomes</li>
                <li>Developing new healthcare protocols and best practices</li>
                <li>Contributing to medical knowledge and innovation</li>
                <li>Preparing statistical reports and aggregated insights</li>
                <li>Quality improvement initiatives</li>
                <h3 className="h3 fw-bold mb-2">
                    4.2.2 Legitimate Business Interests
                </h3>
                <p>We may use information to:</p>
                <li>Prevent fraud and ensure Platform security</li>
                <li>Enforce our Terms of Service and other policies</li>
                <li>Protect the rights and safety of users and the public</li>
                <li>
                    Comply with legal obligations and regulatory requirements
                </li>
                <li>Defend against legal claims or proceedings</li>
                <li>Conduct business planning and strategic development</li>
                <li>
                    Evaluate business transactions (mergers, acquisitions, etc.)
                </li>
                <li>
                    Communicate non-marketing information about our services
                </li>
                <h3 className="h3 fw-bold mb-2">
                    4.2.3 Marketing and Communications
                </h3>
                <p>With your consent, we may use your information to:</p>
                <li>Send promotional content about our services</li>
                <li>Deliver personalized health information and resources</li>
                <li>
                    Invite participation in surveys or research opportunities
                </li>
                <li>Share educational content and healthcare news</li>
                <li>Announce new features or service enhancements</li>
                <li>Provide information about events or webinars</li>
                <h3 className="h3 fw-bold mb-2">
                    4.3 Limitations on Data Usage
                </h3>
                <p>
                    We are committed to using your information responsibly. We
                    will:
                </p>
                <li>
                    Only use your information for purposes disclosed in this
                    Policy
                </li>
                <li>
                    Process data in a manner compatible with the purpose for
                    which it was collected
                </li>
                <li>
                    Limit processing to what is necessary for stated purposes
                </li>
                <li>
                    Not use your information for incompatible purposes without
                    appropriate notice and consent
                </li>
                <li>
                    Not sell your personal information to third parties for
                    their commercial purposes
                </li>
                <li>
                    Not use your information for automated decision-making that
                    produces legal or similarly significant effects without
                    human oversight
                </li>
                <li> Data Sharing and Disclosures</li>
                <li> Categories of Third Parties</li>
                <li>Healthcare Providers and Organizations</li>
                <p>We share your information with:</p>
                <li>
                    U.S.-based physicians and specialists who provide
                    consultations through our Platform
                </li>
                <li>Other healthcare professionals involved in your care</li>
                <li>
                    Pharmacies for prescription fulfillment (where applicable)
                </li>
                <li>
                    Laboratories and diagnostic centers for test orders and
                    results
                </li>
                <li>Health information exchanges for care coordination</li>
                <h3 className="h3 fw-bold mb-2">
                    5.1.2 Service Providers and Vendors
                </h3>
                <p>
                    We share information with third parties who help us operate
                    our Platform:
                </p>
                <li>Cloud hosting and storage providers</li>
                <li>Payment processors and billing services</li>
                <li>Customer support and communication tools</li>
                <li>Identity verification services</li>
                <li>Analytics and performance monitoring services</li>
                <li>Appointment scheduling systems</li>
                <li>Medical language translation services</li>
                <li>Telehealth infrastructure providers</li>
                <li>Electronic health record (EHR) systems</li>
                <li>Quality assessment and accreditation organizations</li>
                <h3 className="h3 fw-bold mb-2">5.1.3 Business Partners</h3>
                <p>We may share information with:</p>
                <li>Healthcare institutions and organizations</li>
                <li>Insurance providers and payers</li>
                <li>Medical device manufacturers (for integrated devices)</li>
                <li>Health monitoring application providers</li>
                <li>
                    Strategic business partners who offer complementary services
                </li>
                <h3 className="h3 fw-bold mb-2">5.2 Purposes for Sharing</h3>
                <p>We share your information for the following purposes:</p>
                <li>
                    <strong>Healthcare Delivery:</strong> To facilitate medical
                    consultations, coordinate care, and provide treatment
                </li>
                <li>
                    <strong>Treatment Continuity:</strong> To ensure seamless
                    healthcare services across providers
                </li>
                <li>
                    <strong>Payment Processing:</strong> To bill for services,
                    verify insurance coverage, and process claims
                </li>
                <li>
                    <strong>Platform Operations:</strong> To maintain and
                    improve our services
                </li>
                <li>
                    <strong>Legal Compliance:</strong> To fulfill regulatory
                    requirements and mandatory reporting
                </li>
                <li>
                    <strong>Research and Innovation:</strong> To advance medical
                    knowledge (with appropriate consent)
                </li>
                <li>
                    <strong>Safety and Security:</strong> To protect users and
                    maintain Platform integrity
                </li>
                <h3 className="h3 fw-bold mb-2">
                    5.3 International Data Transfers and Safeguards
                </h3>
                <li>Cross-Border Data Flows</li>
                <p>
                    Given our operations connecting U.S. physicians with
                    patients in India, data is transferred between these
                    jurisdictions. Specifically:
                </p>
                <li>
                    Patient information from India may be transferred to the
                    U.S. for physician consultation
                </li>
                <li>
                    Consultation records and clinical documentation may be
                    transferred from the U.S. to India
                </li>
                <li>
                    Data may be stored on cloud servers located in various
                    geographic regions
                </li>
                <h3 className="h3 fw-bold mb-2">5.3.2 Transfer Safeguards</h3>
                <p>
                    We implement the following safeguards for international data
                    transfers:
                </p>
                <li>
                    <strong>Standard Contractual Clauses:</strong> We use
                    contract provisions approved by regulatory authorities
                </li>
                <li>
                    <strong>Data Processing Agreements:</strong> We maintain
                    agreements with all data processors that mandate appropriate
                    security measures
                </li>
                <li>
                    <strong>End-to-End Encryption:</strong> We encrypt data in
                    transit and at rest
                </li>
                <li>
                    <strong>Data Minimization:</strong> We transfer only the
                    information necessary for the intended purpose
                </li>
                <li>
                    <strong>Access Controls:</strong> We restrict access to
                    authorized personnel only
                </li>
                <li>
                    <strong>Regular Audits:</strong> We conduct periodic reviews
                    of our data transfer practices
                </li>
                <li>
                    <strong>Localization Where Required:</strong> We store
                    certain data locally when mandated by law
                </li>
                <h3 className="h3 fw-bold mb-2">
                    5.4 Legal and Regulatory Disclosures
                </h3>
                <p>
                    We may disclose your information when legally required,
                    including:
                </p>
                <li>
                    <strong>
                        In response to a court order, subpoena, or similar legal
                        process
                    </strong>
                </li>
                <li>
                    <strong>
                        To comply with laws, regulations, or governmental
                        requests
                    </strong>
                </li>
                <li>
                    <strong>
                        To report suspected abuse, neglect, or domestic violence
                    </strong>
                </li>
                <li>
                    <strong>For public health activities:</strong> Disease
                    reporting, adverse events, etc.
                </li>
                <li>
                    <strong>For health oversight activities:</strong> Audits,
                    investigations, inspections
                </li>
                <li>
                    <strong>
                        To avert a serious threat to health or public safety
                    </strong>
                </li>
                <li>
                    <strong>For specialized government functions:</strong>{" "}
                    National security, military
                </li>
                <li>
                    <strong>For workers’ compensation claims</strong>
                </li>
                <li>
                    <strong>In connection with a business transfer:</strong>{" "}
                    Merger, acquisition, sale of assets
                </li>
                <li>
                    <strong>
                        To enforce our agreements, policies, and terms of use
                    </strong>
                </li>
                <li>
                    <strong>
                        To protect our rights, privacy, safety, or property, or
                        that of others
                    </strong>
                </li>
                <h3 className="h3 fw-bold mb-2">5.5 Limitations on Sharing</h3>
                <p>We limit our data sharing in the following ways:</p>
                <li>
                    <strong>Minimum Necessary Standard:</strong> We disclose
                    only the information required for the intended purpose
                </li>
                <li>
                    <strong>De-identification:</strong> When possible, we
                    de-identify data before sharing for research or analytics
                </li>
                <li>
                    <strong>Consent Requirements:</strong> We obtain consent
                    when required by law before sharing
                </li>
                <li>
                    <strong>No Sale of Data:</strong> We do not sell personal
                    information or PHI to third parties
                </li>
                <li>
                    <strong>Contractual Protections:</strong> We require third
                    parties to maintain appropriate security and confidentiality
                </li>
                <li>
                    <strong>Accountability Mechanisms:</strong> We maintain
                    records of disclosures as required by law
                </li>
                <li>Data Storage and Security</li>
                <li>Data Retention Periods</li>
                <li>General Retention Principles</li>
                <p>
                    We retain your information for as long as needed to provide
                    you with our services and as necessary to comply with our
                    legal obligations, resolve disputes, and enforce our
                    agreements. Specific retention periods vary based on:
                </p>
                <li>
                    <strong>The type of information</strong>
                </li>
                <li>
                    <strong>The purpose for which it was collected</strong>
                </li>
                <li>
                    <strong>Legal and regulatory requirements</strong>
                </li>
                <li>
                    <strong>Operational necessity</strong>
                </li>
                <li>
                    <strong>Risk management considerations</strong>
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.1.2 Specific Retention Periods
                </h3>
                <p>
                    We retain different types of information for specific
                    periods based on legal, regulatory, and operational
                    requirements:
                </p>
                <li>
                    <strong>Medical Records:</strong> We retain healthcare data
                    for a minimum of 7 years or as required by state laws,
                    HIPAA, and other applicable regulations
                </li>
                <li>
                    <strong>Account Information:</strong> We maintain active
                    account data for the duration of your relationship with us
                </li>
                <li>
                    <strong>Payment Information:</strong> We store transaction
                    records for 7 years for tax and accounting purposes
                </li>
                <li>
                    <strong>Communication Records:</strong> We keep records of
                    communications for 3 years
                </li>
                <li>
                    <strong>Technical Data:</strong> We retain logs and
                    analytics data for 18 months
                </li>
                <li>
                    <strong>Marketing Preferences:</strong> We maintain opt-out
                    records indefinitely to honor your choices
                </li>
                <h3 className="h3 fw-bold mb-2">6.1.3 Data Destruction</h3>
                <p>
                    When retention periods expire, we securely delete or
                    anonymize information using industry-standard methods,
                    including:
                </p>
                <li>
                    <strong>Secure overwriting of digital files</strong>
                </li>
                <li>
                    <strong>Cryptographic erasure for encrypted data</strong>
                </li>
                <li>
                    <strong>
                        Physical destruction of storage media when appropriate
                    </strong>
                </li>
                <li>
                    <strong>
                        Anonymization techniques that prevent re-identification
                    </strong>
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.2 Security Measures and Standards
                </h3>
                <h3 className="h3 fw-bold mb-2">Technical Security Controls</h3>
                <p>We implement comprehensive security controls, including:</p>
                <li>
                    <strong>Encryption:</strong> AES-256 encryption for data at
                    rest and TLS 1.3 for data in transit
                </li>
                <li>
                    <strong>Access Management:</strong> Role-based access
                    controls, multi-factor authentication, and privileged access
                    management
                </li>
                <li>
                    <strong>Network Security:</strong> Firewalls, intrusion
                    detection/prevention systems, and regular penetration
                    testing
                </li>
                <li>
                    <strong>Endpoint Protection:</strong> Anti-malware
                    solutions, device management, and security patch management
                </li>
                <li>
                    <strong>Monitoring:</strong> 24/7 security monitoring,
                    logging, and alerting
                </li>
                <li>
                    <strong>Backup Systems:</strong> Regular backups with secure
                    off-site storage
                </li>
                <li>
                    <strong>High Availability:</strong> Redundant systems to
                    ensure service continuity
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.2.2 Administrative Safeguards
                </h3>
                <p>Our administrative security measures include:</p>
                <li>
                    <strong>Security Policies:</strong> Comprehensive policies
                    and procedures governing data handling
                </li>
                <li>
                    <strong>Staff Training:</strong> Regular security awareness
                    training for all personnel
                </li>
                <li>
                    <strong>Background Checks:</strong> Pre-employment screening
                    for employees with access to sensitive data
                </li>
                <li>
                    <strong>Security Certifications:</strong> Compliance with
                    industry standards and security frameworks
                </li>
                <li>
                    <strong>Vendor Assessment:</strong> Thorough security
                    evaluation of third-party service providers
                </li>
                <li>
                    <strong>Incident Response Plan:</strong> Documented
                    procedures for handling security incidents
                </li>
                <li>
                    <strong>Regular Audits:</strong> Internal and external
                    security assessments
                </li>
                <h3 className="h3 fw-bold mb-2">6.2.3 Physical Security</h3>
                <p>For facilities housing our systems:</p>
                <li>
                    <strong>Access Controls:</strong> Restricted physical access
                    to server rooms and data centers
                </li>
                <li>
                    <strong>Environmental Controls:</strong> Climate control,
                    fire suppression, and power redundancy
                </li>
                <li>
                    <strong>Surveillance:</strong> Video monitoring and security
                    personnel
                </li>
                <li>
                    <strong>Media Handling:</strong> Secure disposal of physical
                    media containing sensitive information
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.3 Encryption and Anonymization Practices
                </h3>
                <p>Encryption Implementation</p>
                <li>
                    <strong>Data at Rest:</strong> All stored PHI and sensitive
                    personal information is encrypted
                </li>
                <li>
                    <strong>Data in Transit:</strong> All network communications
                    use TLS 1.3 or higher
                </li>
                <li>
                    <strong>End-to-End Encryption:</strong> For telemedicine
                    sessions and sensitive communications
                </li>
                <li>
                    <strong>Key Management:</strong> Secure generation, storage,
                    and rotation of encryption keys
                </li>
                <li>
                    <strong>Mobile Applications:</strong> Local encryption for
                    data stored on mobile devices
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.3.2 Anonymization and Pseudonymization
                </h3>
                <p>
                    For data used in analytics, research, and non-direct care
                    purposes:
                </p>
                <li>
                    <strong>De-identification Techniques:</strong> Removal of
                    direct and indirect identifiers
                </li>
                <li>
                    <strong>Aggregation:</strong> Combining data to prevent
                    individual identification
                </li>
                <li>
                    <strong>Tokenization:</strong> Replacing sensitive values
                    with non-sensitive equivalents
                </li>
                <li>
                    <strong>Statistical Disclosure Control:</strong> Methods to
                    minimize re-identification risk
                </li>
                <li>
                    <strong>Expert Determination:</strong> Review of
                    de-identification methods by qualified experts
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.4 Breach Notification Procedures
                </h3>
                <p>
                    In the event of a data breach affecting your personal
                    information or PHI:
                </p>
                <h3 className="h3 fw-bold mb-2">6.4.1 Internal Response</h3>
                <p>
                    In the event of a data breach, we will take the following
                    internal response measures:
                </p>
                <li>
                    <strong>Incident Response Activation:</strong> We will
                    activate our incident response team
                </li>
                <li>
                    <strong>Containment:</strong> Immediate actions to contain
                    and investigate the breach
                </li>
                <li>
                    <strong>Assessment:</strong> Evaluation of the nature and
                    scope of the affected information
                </li>
                <li>
                    <strong>Mitigation:</strong> Implementation of measures to
                    minimize harm
                </li>
                <li>
                    <strong>Documentation:</strong> Recording of the incident
                    and response actions for compliance and review
                </li>
                <h3 className="h3 fw-bold mb-2">
                    6.4.2 Notification Timelines
                </h3>
                <p>
                    In the event of a data breach, we will notify affected
                    individuals within the required timeframes:
                </p>
                <li>
                    <strong>PHI Breaches:</strong> For breaches involving PHI,
                    we will notify affected individuals without unreasonable
                    delay and no later than 60 calendar days after discovery, as
                    required by HIPAA.
                </li>
                <li>
                    <strong>Personal Data Breaches:</strong> For other personal
                    data breaches, we will notify affected individuals in
                    accordance with applicable laws, including GDPR (72 hours to
                    authorities) and state breach notification laws.
                </li>
                <h3 className="h3 fw-bold mb-2">6.4.3 Notification Content</h3>
                <p>Our notifications will include the following details:</p>
                <li>
                    <strong>Description of the breach:</strong> A summary of
                    what happened and when it was discovered.
                </li>
                <li>
                    <strong>Types of information involved:</strong> Details on
                    the categories of affected data.
                </li>
                <li>
                    <strong>
                        Steps individuals can take to protect themselves:
                    </strong>{" "}
                    Recommended actions to mitigate potential risks.
                </li>
                <li>
                    <strong>
                        Measures we are taking to investigate and mitigate:
                    </strong>{" "}
                    Efforts to address and prevent future breaches.
                </li>
                <li>
                    <strong>
                        Contact information for questions and additional
                        information:
                    </strong>{" "}
                    How affected individuals can reach us for further
                    assistance.
                </li>
                <h3 className="h3 fw-bold mb-2">6.4.4 Regulatory Reporting</h3>
                <p>
                    We will notify relevant regulatory authorities as required
                    by law, including:
                </p>
                <li>
                    <strong>
                        U.S. Department of Health and Human Services:
                    </strong>{" "}
                    For breaches involving PHI, as mandated by HIPAA.
                </li>
                <li>
                    <strong>State attorneys general:</strong> Where required by
                    state data breach notification laws.
                </li>
                <li>
                    <strong>Data protection authorities:</strong> For breaches
                    affecting EU residents, in compliance with GDPR.
                </li>
                <li>
                    <strong>Indian regulatory authorities:</strong> As
                    applicable under local data protection regulations.
                </li>
                <h3 className="h3 fw-bold mb-2">7. User Rights and Choices</h3>
                <p>Your Privacy Rights</p>
                <p>
                    Depending on your location and applicable laws, you may have
                    the following rights regarding your personal information:
                </p>
                <h3 className="h3 fw-bold mb-2">7.1.1 Access Rights</h3>
                <li>Right to Know</li>
                <p>
                    You can request information about what personal data we
                    collect, use, disclose, and sell.
                </p>
                <li>Right to Access</li>
                <p>
                    You can request a copy of your personal information in our
                    records.
                </p>
                <li>Right to Confirmation</li>
                <p>You can ask whether we process your personal data.</p>
                <h3 className="h3 fw-bold mb-2">7.1.2 Correction Rights</h3>
                <li>Right to Rectification</li>
                <p>
                    You can request that we correct inaccurate personal
                    information.
                </p>
                <li>Right to Complete</li>
                <p>You can ask us to complete incomplete information.</p>
                <li>Right to Update</li>
                <p>
                    You can update your profile information directly through
                    your account settings.
                </p>
                <h3 className="h3 fw-bold mb-2">7.1.3 Deletion Rights</h3>
                <li>Right to Erasure</li>
                <p>
                    You can request deletion of your personal information in
                    certain circumstances.
                </p>
                <li>Right to be Forgotten</li>
                <p>You can ask us to remove your data from our systems.</p>
                <li>Limitations</li>
                <p>
                    Some information may be retained for legal, compliance, or
                    business purposes.
                </p>
                <h3 className="h3 fw-bold mb-2">7.1.4 Control Rights</h3>
                <li>Right to Restrict Processing</li>
                <p>You can request limits on how we use your data.</p>
                <li>Right to Object</li>
                <p>You can object to certain processing activities.</p>
                <li>Right to Opt-Out</li>
                <p>
                    You can opt-out of certain disclosures, sales of personal
                    information, or the use of sensitive personal information.
                </p>
                <li>Right to Non-Discrimination</li>
                <p>
                    We will not discriminate against you for exercising your
                    rights.
                </p>
                <h3 className="h3 fw-bold mb-2">7.1.5 Portability Rights</h3>
                <li>Right to Data Portability</li>
                <p>
                    You can request your personal information in a structured,
                    commonly used, and machine-readable format.
                </p>
                <li>Right to Transfer</li>
                <p>
                    You can ask us to transmit your data directly to another
                    controller, when technically feasible.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    7.2 How to Exercise Your Rights
                </h3>
                <li>Submission Methods</li>
                <p>You can submit requests to exercise your rights through:</p>
                <li>Online Form</li>
                <p>Available in your account settings or our privacy portal.</p>
                <li>Email</li>
                <p>privacy@secopp.com</p>
                <li>Postal Mail</li>
                <p>
                    Second Opinion USA LLC, Attn: Privacy Office, 3748 Dover Dr,
                    Birmingham, AL – 35223
                </p>
                <h3 className="h3 fw-bold mb-2">7.2.2 Verification Process</h3>
                <p>
                    To protect your information, we need to verify your identity
                    before processing your request:
                </p>
                <li>Account Holders</li>
                <p>
                    We will verify your identity through your account
                    credentials.
                </p>
                <li>Non-Account Holders</li>
                <p>
                    We may request additional information to verify your
                    identity.
                </p>
                <li>Authorized Agents</li>
                <p>
                    If using an authorized agent, we require written permission
                    and identity verification.
                </p>
                <h3 className="h3 fw-bold mb-2">7.2.3 Response Timeline</h3>
                <p>
                    We aim to respond to all verifiable requests within 30 days.
                </p>
                <li>Extension</li>
                <p>
                    If necessary, we may extend the response time by an
                    additional 30 days, with notification.
                </p>
                <li>Complex Requests</li>
                <p>
                    For complex requests, we will keep you informed about the
                    status of your request.
                </p>
                <h3 className="h3 fw-bold mb-2">7.2.4 Response Format</h3>
                <p>
                    We will provide information in a concise, transparent,
                    intelligible, and easily accessible form.
                </p>
                <li>Clarity</li>
                <p>We will use clear and plain language.</p>
                <li>Delivery</li>
                <p>
                    Information will be provided in writing or electronically in
                    a commonly used format.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    7.3 Jurisdiction-Specific Rights
                </h3>
                <h4 className="h4 fw-semibold mt-2">
                    HIPAA Rights (United States)
                </h4>
                <p>
                    As a covered entity under HIPAA, we provide patients with:
                </p>
                <li>Right to Access</li>
                <p>
                    Right to access and obtain copies of their health records.
                </p>
                <li>Right to Amend</li>
                <p>Right to request amendments to records.</p>
                <li>Right to Disclosure Accounting</li>
                <p>Right to an accounting of disclosures.</p>
                <li>Right to Restrict Processing</li>
                <p>
                    Right to request restrictions on certain uses and
                    disclosures.
                </p>
                <li>Right to Confidential Communications</li>
                <p>
                    Right to request private communications regarding health
                    information.
                </p>
                <li>Right to File a Complaint</li>
                <p>Right to file a complaint with the covered entity or HHS.</p>
                <h3 className="h3 fw-bold mb-2">
                    7.3.2 GDPR Rights (European Union)
                </h3>
                <p>
                    For individuals protected by the GDPR, additional rights
                    include:
                </p>
                <li>Right to Withdraw Consent</li>
                <p>Right to withdraw consent at any time.</p>
                <li>Right to Lodge a Complaint</li>
                <p>Right to lodge a complaint with a supervisory authority.</p>
                <li>Rights Related to Automated Decision-Making</li>
                <p>
                    Rights related to automated decision-making and profiling.
                </p>
                <li>Right to Cross-Border Safeguards</li>
                <p>
                    Right to be informed about the appropriate safeguards where
                    data is transferred to a third country.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    7.3.3 CCPA/CPRA Rights (California)
                </h3>
                <p>California residents have specific rights, including:</p>
                <li>Right to Know</li>
                <p>
                    Right to know about personal information collected,
                    disclosed, or sold.
                </p>
                <li>Right to Delete</li>
                <p>
                    Right to delete personal information collected from the
                    consumer.
                </p>
                <li>Right to Opt-Out</li>
                <p>
                    Right to opt-out of the sale or sharing of personal
                    information.
                </p>
                <li>Right to Limit Use</li>
                <p>
                    Right to limit use and disclosure of sensitive personal
                    information.
                </p>
                <li>Right to Non-Discrimination</li>
                <p>
                    Right to non-discrimination for exercising consumer rights.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    7.3.4 Other State-Specific Rights
                </h3>
                <p>
                    Residents of other states may have additional rights under
                    applicable state laws, which we will honor in accordance
                    with those laws.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    7.4 Limitations and Exceptions
                </h3>
                <p>
                    In some cases, we may be unable to fulfill your rights
                    requests due to:
                </p>
                <ul>
                    <li>
                        <strong>Legal Obligations:</strong> Legal obligations
                        requiring retention of information.
                    </li>
                    <li>
                        <strong>Legitimate Business Needs:</strong> Legitimate
                        business needs for the information.
                    </li>
                    <li>
                        <strong>Technical Limitations:</strong> Technical
                        limitations preventing data deletion or modification.
                    </li>
                    <li>
                        <strong>Protection of Rights:</strong> Protection of the
                        rights of others.
                    </li>
                    <li>
                        <strong>Unfounded or Excessive Requests:</strong>{" "}
                        Requests that are manifestly unfounded or excessive.
                    </li>
                </ul>
                <p>
                    When we cannot fulfill a request, we will explain the
                    reasons and inform you of your right to complain to the
                    relevant supervisory authority.
                </p>
                <li>8. Consent Management</li>
                <li>8.1 Obtaining Consent</li>
                <li>8.1.1 Methods of Consent Collection</li>
                <p>We obtain consent through:</p>
                <li>
                    <strong>Explicit Consent Forms:</strong> Digital forms with
                    clear consent language.
                </li>
                <li>
                    <strong>Click-through Agreements:</strong> During account
                    creation and registration.
                </li>
                <li>
                    <strong>Checkboxes:</strong> Clearly labeled opt-in
                    checkboxes for specific processing activities.
                </li>
                <li>
                    <strong>Digital Signatures:</strong> For telehealth consent
                    and authorization forms.
                </li>
                <li>
                    <strong>Verbal Consent:</strong> Recorded in certain
                    telehealth contexts, with documentation.
                </li>
                <li>
                    <strong>Granular Options:</strong> Separate consent for
                    different processing activities.
                </li>
                <li>
                    <strong>Just-in-Time Notices:</strong> Contextual consent
                    requests at the point of data collection.
                </li>
                <h5 className="h5 fw-bold mb-2">8.1.2 Consent Requirements</h5>
                <p>Our consent mechanisms ensure that consent is:</p>
                <li>
                    <strong>Freely Given:</strong> Obtained without pressure or
                    conditional terms.
                </li>
                <li>
                    <strong>Specific:</strong> Clearly explaining each purpose
                    for which consent is sought.
                </li>
                <li>
                    <strong>Informed:</strong> Accompanied by clear information
                    about the processing.
                </li>
                <li>
                    <strong>Unambiguous:</strong> Requiring a clear affirmative
                    action.
                </li>
                <li>
                    <strong>Demonstrable:</strong> Recorded and documented for
                    compliance purposes.
                </li>
                <li>
                    <strong>Accessible:</strong> Presented in clear, plain
                    language.
                </li>
                <li>
                    <strong>Distinguishable:</strong> Separate from other terms
                    and conditions.
                </li>
                <li>
                    <strong>Revocable:</strong> With clear information on how to
                    withdraw consent.
                </li>
                <h5 className="h5 fw-bold mb-2">
                    8.1.3 Special Categories of Consent
                </h5>
                <p>We implement enhanced consent procedures for:</p>
                <li>
                    <strong>Healthcare Services:</strong> Informed consent for
                    telehealth treatment.
                </li>
                <li>
                    <strong>Research Participation:</strong> Separate consent
                    for any research activities.
                </li>
                <li>
                    <strong>Marketing Communications:</strong> Explicit opt-in
                    for promotional messages.
                </li>
                <li>
                    <strong>Cookie Consent:</strong> Granular options for
                    different types of cookies.
                </li>
                <li>
                    <strong>International Data Transfers:</strong> Specific
                    consent for cross-border transfers.
                </li>
                <li>
                    <strong>Minor’s Data:</strong> Parental/guardian consent
                    process.
                </li>
                <h3 className="h3 fw-bold mb-2">8.2 Withdrawal of Consent</h3>
                <p>
                    You can withdraw previously granted consent through the
                    following mechanisms:
                </p>
                <li>
                    <strong>Account Settings:</strong> Self-service preference
                    center.
                </li>
                <li>
                    <strong>Unsubscribe Links:</strong> One-click unsubscribe in
                    all marketing communications.
                </li>
                <li>
                    <strong>Privacy Portal:</strong> Centralized consent
                    management interface.
                </li>
                <li>
                    <strong>Customer Support:</strong> Assistance with consent
                    withdrawal requests.
                </li>
                <li>
                    <strong>Written Requests:</strong> Via email or postal mail.
                </li>
                <h3 className="h3 fw-bold mb-2">8.2.2 Effects of Withdrawal</h3>
                <p>Upon withdrawal of consent:</p>
                <li>
                    <strong>Cease Processing:</strong> We will stop processing
                    data based on that consent.
                </li>
                <li>
                    <strong>Lawfulness of Prior Processing:</strong> Processing
                    performed prior to withdrawal remains lawful.
                </li>
                <li>
                    <strong>Alternative Legal Bases:</strong> Certain processing
                    may continue under other legal justifications.
                </li>
                <li>
                    <strong>Service Limitations:</strong> Some services may be
                    restricted or unavailable if essential processing cannot
                    continue.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    8.2.3 Processing Withdrawal Requests
                </h3>
                <p>We handle consent withdrawal by:</p>
                <li>
                    <strong>Confirmation of Receipt:</strong> Promptly
                    acknowledging the request.
                </li>
                <li>
                    <strong>Timely Processing:</strong> Handling withdrawal
                    requests without undue delay.
                </li>
                <li>
                    <strong>System Updates:</strong> Updating our systems to
                    reflect consent changes.
                </li>
                <li>
                    <strong>Partner Notification:</strong> Informing relevant
                    processors and partners.
                </li>
                <li>
                    <strong>Compliance Documentation:</strong> Recording the
                    withdrawal for compliance purposes.
                </li>
                <li>
                    <strong>Final Confirmation:</strong> Providing confirmation
                    once the withdrawal has been processed.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    8.3 Special Provisions for Vulnerable Populations
                </h3>
                <h4 className="h4 fw-bold mt-3">Minors (Under 18)</h4>
                <p>For users under 18 years of age:</p>
                <li>
                    <strong>Parental Consent:</strong> Required for users under
                    13 (under 16 in some jurisdictions).
                </li>
                <li>
                    <strong>Verification Methods:</strong> Age verification and
                    parent/guardian identity confirmation.
                </li>
                <li>
                    <strong>Guardian Authorization:</strong> Medical
                    decision-makers must authorize healthcare services.
                </li>
                <li>
                    <strong>Age-Appropriate Language:</strong> Consent forms
                    designed for comprehension.
                </li>
                <li>
                    <strong>Additional Safeguards:</strong> Enhanced privacy
                    protections for minors’ data.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    8.3.2 Individuals with Limited Capacity
                </h3>
                <p>For those with limited decision-making capacity:</p>
                <li>
                    <strong>Legal Representatives:</strong> Authorized
                    representatives may provide consent.
                </li>
                <li>
                    <strong>Power of Attorney:</strong> Recognition of
                    healthcare proxies and legal guardians.
                </li>
                <li>
                    <strong>Accessible Formats:</strong> Consent materials in
                    formats appropriate to different abilities.
                </li>
                <li>
                    <strong>Documentation Requirements:</strong> Additional
                    verification and record-keeping.
                </li>
                <li>
                    <strong>Best Interest Assessment:</strong> Consideration of
                    the individual’s best interests.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    8.3.3 Language and Accessibility
                </h3>
                <p>To ensure informed consent across populations:</p>
                <li>
                    <strong>Multiple Languages:</strong> Consent materials
                    available in languages common to our user base.
                </li>
                <li>
                    <strong>Plain Language:</strong> Information presented at an
                    8th-grade reading level.
                </li>
                <li>
                    <strong>Assistive Technology Support:</strong> Compatibility
                    with screen readers and other tools.
                </li>
                <li>
                    <strong>Visual Aids:</strong> Graphics and videos to enhance
                    understanding.
                </li>
                <li>
                    <strong>Support Options:</strong> Availability of human
                    assistance for consent questions.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    8.4 Consent Records and Documentation
                </h3>
                <p>We maintain comprehensive records of consent, including:</p>
                <li>
                    <strong>Date, Time, and Method of Consent:</strong> Records
                    of when and how consent was obtained.
                </li>
                <li>
                    <strong>Version of Privacy Notices:</strong> Documentation
                    of the privacy notices presented at the time of consent.
                </li>
                <li>
                    <strong>Specific Purposes:</strong> Details on the purposes
                    for which consent was given.
                </li>
                <li>
                    <strong>Identity Verification Methods:</strong> Confirmation
                    of how consent was verified.
                </li>
                <li>
                    <strong>Withdrawal of Consent:</strong> Documentation of
                    consent withdrawals and related actions.
                </li>
                <li>
                    <strong>Parental/Guardian Consent:</strong> Records of
                    consent provided for minors.
                </li>
                <li>
                    <strong>Consent Renewal and Updates:</strong> Tracking of
                    consent updates and renewals.
                </li>
                <h3 className="h3 fw-bold mb-2">9.1.2 Functional Cookies</h3>
                <p>
                    These cookies enable enhanced functionality but are not
                    essential:
                </p>
                <ul>
                    <li>
                        <strong>Preference Cookies:</strong> Remember your
                        settings and choices.
                    </li>
                    <li>
                        <strong>Language Cookies:</strong> Store your language
                        preference.
                    </li>
                    <li>
                        <strong>Location Cookies:</strong> Remember your general
                        location for relevant content.
                    </li>
                    <li>
                        <strong>Accessibility Cookies:</strong> Store
                        accessibility settings.
                    </li>
                    <li>
                        <strong>Form Completion Cookies:</strong> Remember
                        information you’ve entered in forms.
                    </li>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.1.3 Analytics Cookies</h3>
                <p>
                    These cookies help us understand how visitors interact with
                    our Platform:
                </p>
                <li>
                    <strong>Performance Measurement:</strong> Track page load
                    times and server response times.
                </li>
                <li>
                    <strong>User Behavior Analysis:</strong> Monitor navigation
                    patterns and feature usage.
                </li>
                <li>
                    <strong>Error Tracking:</strong> Identify technical issues
                    and errors.
                </li>
                <li>
                    <strong>A/B Testing Cookies:</strong> Support comparison of
                    different versions of our service.
                </li>
                <li>
                    <strong>Heatmap and Session Recording Cookies:</strong>{" "}
                    Analyze how users interact with pages.
                </li>
                <h3 className="h3 fw-bold mb-2">
                    9.1.4 Marketing and Advertising Cookies
                </h3>
                <p>These optional cookies are used for marketing purposes:</p>
                <ul>
                    <li>
                        <strong>Conversion Tracking:</strong> Measure the
                        effectiveness of marketing campaigns.
                    </li>
                    <li>
                        <strong>Retargeting Cookies:</strong> Enable delivery of
                        relevant advertisements.
                    </li>
                    <li>
                        <strong>Social Media Cookies:</strong> Support sharing
                        and integration with social platforms.
                    </li>
                    <li>
                        <strong>Affiliate Tracking:</strong> Monitor referrals
                        from partner websites.
                    </li>
                    <li>
                        <strong>Interest-Based Advertising:</strong> Build
                        profiles of interests for targeted ads.
                    </li>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.2 Purpose and Control</h3>
                <h4 className="h4 fw-bold mt-3">
                    How We Use These Technologies
                </h4>
                <p>We use cookies and similar technologies to:</p>
                <ul>
                    <li>
                        <strong>Maintain Security:</strong> Protect user
                        accounts and prevent fraud.
                    </li>
                    <li>
                        <strong>Enhance Experience:</strong> Provide a
                        personalized and efficient Platform.
                    </li>
                    <li>
                        <strong>Analyze Performance:</strong> Identify areas for
                        improvement.
                    </li>
                    <li>
                        <strong>Support Features:</strong> Enable interactive
                        elements and user preferences.
                    </li>
                    <li>
                        <strong>Measure Effectiveness:</strong> Evaluate our
                        marketing and communication efforts.
                    </li>
                    <li>
                        <strong>Improve Content:</strong> Understand what
                        information is most valuable to users.
                    </li>
                    <li>
                        <strong>Technical Functionality:</strong> Ensure the
                        Platform works correctly across devices.
                    </li>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    9.2.2 Cookie Consent Management
                </h3>
                <p>
                    We provide tools for you to control your cookie preferences:
                </p>
                <ul>
                    <li>
                        <strong>Cookie Banner:</strong> Clear notice upon first
                        visit with consent options.
                    </li>
                    <li>
                        <strong>Preference Center:</strong> Granular controls to
                        manage cookie categories.
                    </li>
                    <li>
                        <strong>Browser Settings:</strong> Information on
                        blocking cookies through browser settings.
                    </li>
                    <li>
                        <strong>Opt-Out Links:</strong> Direct links to opt out
                        of analytics and advertising tracking.
                    </li>
                    <li>
                        <strong>Do Not Track:</strong> Recognition of browser Do
                        Not Track signals where required by law.
                    </li>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.2.3 Third-Party Cookies</h3>
                <p>Some cookies are placed by third parties on our Platform:</p>
                <ul>
                    <li>
                        <strong>Third-Party Cookie Details:</strong> We provide
                        details about third-party cookies in our Cookie Policy.
                    </li>
                    <li>
                        <strong>Privacy Compliance:</strong> We contractually
                        require third parties to respect privacy preferences.
                    </li>
                    <li>
                        <strong>Regular Review:</strong> We periodically review
                        third-party cookie usage for compliance.
                    </li>
                    <li>
                        <strong>Transparency:</strong> We offer links to
                        third-party privacy policies for transparency.
                    </li>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    9.3 Cookie Lifespan and Storage
                </h3>
                <p>
                    We categorize cookies based on their lifespan and storage
                    duration:
                </p>
                <ul>
                    <li>
                        <strong>Session Cookies:</strong>
                    </li>
                    <p>
                        Temporary cookies that exist only during your browsing
                        session.
                    </p>
                    <p>Deleted automatically when you close your browser.</p>
                    <p>Do not collect information from your device.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.3.2 Persistent Cookies</h3>
                <p>
                    Persistent cookies remain on your device between browsing
                    sessions:
                </p>
                <ul>
                    <li>
                        <strong>Long-Term Storage:</strong>
                    </li>
                    <p>Remain on your device between browsing sessions.</p>

                    <li>
                        <strong>Expiration Period:</strong>
                    </li>
                    <p>
                        Have expiration dates ranging from 30 days to 2 years.
                    </p>

                    <li>
                        <strong>Functionality:</strong>
                    </li>
                    <p>
                        Used for remembering preferences and providing
                        continuity.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    9.4 Other Tracking Technologies
                </h3>
                <p>
                    We use additional tracking technologies to enhance analytics
                    and marketing efforts.
                </p>
                <ul>
                    <li>
                        <strong>Web Beacons and Pixels:</strong>
                    </li>
                    <p>
                        Small transparent images that track page views and email
                        opens.
                    </p>

                    <li>
                        <strong>User Engagement Analysis:</strong>
                    </li>
                    <p>Help us understand user engagement with content.</p>

                    <li>
                        <strong>Advertising Effectiveness:</strong>
                    </li>
                    <p>
                        Used to measure the effectiveness of advertising
                        campaigns.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.4.2 Local Storage</h3>
                <p>
                    We use local storage technologies to enhance performance and
                    functionality.
                </p>
                <ul>
                    <li>
                        <strong>HTML5 Storage:</strong>
                    </li>
                    <p>Storage mechanisms that persist data on your device.</p>

                    <li>
                        <strong>Improved Performance:</strong>
                    </li>
                    <p>Used for faster load times and offline functionality.</p>

                    <li>
                        <strong>Privacy Controls:</strong>
                    </li>
                    <p>Subject to the same privacy controls as cookies.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.4.3 Device Fingerprinting</h3>
                <p>
                    We use device fingerprinting for security and fraud
                    prevention.
                </p>
                <ul>
                    <li>
                        <strong>Unique Identification:</strong>
                    </li>
                    <p>
                        Collection of device attributes to identify unique
                        browsers.
                    </p>

                    <li>
                        <strong>Fraud Prevention:</strong>
                    </li>
                    <p>Used to detect and prevent fraudulent activities.</p>

                    <li>
                        <strong>Legitimate Use:</strong>
                    </li>
                    <p>
                        Limited to necessary identification for security and
                        compliance purposes.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">9.5 Cookie Policy</h3>
                <p>
                    For more detailed information about the specific cookies we
                    use, their purposes, and your choices, please refer to our
                    separate
                    <strong>Cookie Policy</strong>, which is incorporated by
                    reference into this Privacy Policy.
                </p>
                <h3 className="h3 fw-bold mb-2">
                    Special Provisions for Healthcare Data
                </h3>
                <h3 className="h3 fw-bold mb-2">HIPAA Compliance Measures</h3>
                <h3 className="h4 fw-bold mb-2">Privacy Rule Compliance</h3>
                <p>
                    As a covered entity and business associate under HIPAA, we
                    implement:
                </p>
                <ul>
                    <li>
                        <strong>Notice of Privacy Practices:</strong>
                    </li>
                    <p>Comprehensive information about PHI handling.</p>

                    <li>
                        <strong>Minimum Necessary Standard:</strong>
                    </li>
                    <p>
                        Limiting PHI access and disclosure to what is required.
                    </p>

                    <li>
                        <strong>Patient Rights Implementation:</strong>
                    </li>
                    <p>
                        Processes to fulfill access, amendment, and accounting
                        requests.
                    </p>

                    <li>
                        <strong>Workforce Training:</strong>
                    </li>
                    <p>Regular HIPAA training for all staff with PHI access.</p>

                    <li>
                        <strong>Privacy Officer:</strong>
                    </li>
                    <p>
                        Designated individual responsible for privacy policies
                        and compliance.
                    </p>

                    <li>
                        <strong>Administrative Safeguards:</strong>
                    </li>
                    <p>Policies and procedures for PHI protection.</p>

                    <li>
                        <strong>Business Associate Agreements:</strong>
                    </li>
                    <p>Contracts ensuring third-party compliance.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.1.2 Security Rule Compliance
                </h3>
                <p>Our technical safeguards include:</p>
                <ul>
                    <li>
                        <strong>Risk Analysis:</strong>
                    </li>
                    <p>
                        Regular assessment of potential risks to electronic PHI.
                    </p>

                    <li>
                        <strong>Risk Management:</strong>
                    </li>
                    <p>
                        Implementation of security measures to reduce identified
                        risks.
                    </p>

                    <li>
                        <strong>Access Controls:</strong>
                    </li>
                    <p>
                        Technical policies limiting ePHI access to authorized
                        persons.
                    </p>

                    <li>
                        <strong>Audit Controls:</strong>
                    </li>
                    <p>
                        Hardware, software, and procedural mechanisms to record
                        activity.
                    </p>

                    <li>
                        <strong>Integrity Controls:</strong>
                    </li>
                    <p>
                        Measures to ensure ePHI is not improperly altered or
                        destroyed.
                    </p>

                    <li>
                        <strong>Transmission Security:</strong>
                    </li>
                    <p>Technical security measures for data transmission.</p>

                    <li>
                        <strong>Device and Media Controls:</strong>
                    </li>
                    <p>Policies governing receipt and removal of hardware.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.1.3 Breach Notification Rule
                </h3>
                <p>Our breach response protocols include:</p>
                <ul>
                    <li>
                        <strong>Breach Definition:</strong>
                    </li>
                    <p>Clear understanding of what constitutes a breach.</p>

                    <li>
                        <strong>Risk Assessment Process:</strong>
                    </li>
                    <p>Methodology to evaluate breach impact.</p>

                    <li>
                        <strong>Notification Procedures:</strong>
                    </li>
                    <p>
                        Processes for timely notification to affected
                        individuals.
                    </p>

                    <li>
                        <strong>Documentation:</strong>
                    </li>
                    <p>
                        Comprehensive record-keeping of breach incidents and
                        responses.
                    </p>

                    <li>
                        <strong>Workforce Training:</strong>
                    </li>
                    <p>Education on breach identification and reporting.</p>

                    <li>
                        <strong>Mitigation Strategies:</strong>
                    </li>
                    <p>Plans to minimize harm from breaches.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.2 Notice of Privacy Practices Integration
                </h3>
                <p>We provide our Notice of Privacy Practices:</p>
                <ul>
                    <li>
                        <strong>During Initial Registration:</strong>
                    </li>
                    <p>Provided upon signing up on our Platform.</p>

                    <li>
                        <strong>Upon Request:</strong>
                    </li>
                    <p>Available at any time upon user request.</p>

                    <li>
                        <strong>Website Link:</strong>
                    </li>
                    <p>Accessible via a prominent link on our website.</p>

                    <li>
                        <strong>Material Updates:</strong>
                    </li>
                    <p>
                        Issued in an updated form when material changes occur.
                    </p>

                    <li>
                        <strong>Accessible Formats:</strong>
                    </li>
                    <p>
                        Available in formats suitable for individuals with
                        disabilities.
                    </p>

                    <li>
                        <strong>Multiple Languages:</strong>
                    </li>
                    <p>
                        Offered in multiple languages for non-English speakers.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">10.2.2 Content of Notice</h3>
                <p>Our Notice of Privacy Practices includes:</p>
                <ul>
                    <li>
                        <strong>Use and Disclosure of PHI:</strong>
                    </li>
                    <p>
                        Details on how we may use and disclose Protected Health
                        Information (PHI).
                    </p>

                    <li>
                        <strong>Individual Rights:</strong>
                    </li>
                    <p>
                        Information on rights regarding access, amendments, and
                        control over PHI.
                    </p>

                    <li>
                        <strong>Legal Duties:</strong>
                    </li>
                    <p>
                        Our obligations to protect the privacy and security of
                        PHI.
                    </p>

                    <li>
                        <strong>Complaint Procedures:</strong>
                    </li>
                    <p>
                        Guidance on how to file complaints regarding privacy
                        concerns.
                    </p>

                    <li>
                        <strong>Contact Information:</strong>
                    </li>
                    <p>
                        Details on how to reach us for privacy-related
                        questions.
                    </p>

                    <li>
                        <strong>Effective Date and Revisions:</strong>
                    </li>
                    <p>
                        Information on when the notice takes effect and any
                        revisions made.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.2.3 Acknowledgment of Receipt
                </h3>
                <p>We maintain records of:</p>
                <ul>
                    <li>
                        <strong>User Acknowledgment:</strong>
                    </li>
                    <p>
                        Confirmation that users have received and reviewed the
                        Notice of Privacy Practices.
                    </p>

                    <li>
                        <strong>Good Faith Efforts:</strong>
                    </li>
                    <p>
                        Documentation of our efforts to obtain user
                        acknowledgment.
                    </p>

                    <li>
                        <strong>Alternative Delivery Methods:</strong>
                    </li>
                    <p>
                        Providing the Notice through alternative means when
                        electronic delivery is not feasible.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.3 Handling of Treatment, Payment, and Operations Data
                </h3>
                <h4 className="h4 fw-bold mt-3">Treatment Data</h4>
                <p>Information used for patient care is:</p>
                <ul>
                    <li>
                        <strong>Restricted Access:</strong>
                    </li>
                    <p>
                        Accessible only to treating providers and support staff.
                    </p>

                    <li>
                        <strong>Care Coordination:</strong>
                    </li>
                    <p>
                        Shared between providers only for coordination of care.
                    </p>

                    <li>
                        <strong>Additional Safeguards:</strong>
                    </li>
                    <p>
                        Subject to enhanced protections for sensitive
                        conditions, including mental health, substance use, HIV
                        status, and genetic information.
                    </p>

                    <li>
                        <strong>Secure Telehealth Transmission:</strong>
                    </li>
                    <p>
                        Protected during telehealth sessions through secure
                        transmission methods.
                    </p>

                    <li>
                        <strong>Medical Record Compliance:</strong>
                    </li>
                    <p>
                        Documented in accordance with medical record retention
                        and regulatory requirements.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">10.3.2 Payment Data</h3>
                <p>Information used for billing and reimbursement is:</p>
                <ul>
                    <li>
                        <strong>Minimum Necessary Use:</strong>
                    </li>
                    <p>
                        Limited to the minimum necessary for processing
                        payments.
                    </p>

                    <li>
                        <strong>Authorized Sharing:</strong>
                    </li>
                    <p>
                        Shared with payers and financial institutions as
                        required.
                    </p>

                    <li>
                        <strong>Secure Handling:</strong>
                    </li>
                    <p>Secured during transmission and storage.</p>

                    <li>
                        <strong>Retention Compliance:</strong>
                    </li>
                    <p>Retained according to financial record requirements.</p>

                    <li>
                        <strong>Accounting Controls:</strong>
                    </li>
                    <p>Subject to appropriate accounting controls.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.3.3 Healthcare Operations Data
                </h3>
                <p>Information used for operational activities is:</p>
                <ul>
                    <li>
                        <strong>Access Control:</strong>
                    </li>
                    <p>Limited to authorized personnel.</p>

                    <li>
                        <strong>Quality Improvement:</strong>
                    </li>
                    <p>Used for quality assessment and improvement.</p>

                    <li>
                        <strong>Credentialing and Evaluation:</strong>
                    </li>
                    <p>
                        Applied to provider credentialing and performance
                        evaluation.
                    </p>

                    <li>
                        <strong>Business Development:</strong>
                    </li>
                    <p>Utilized for business planning and development.</p>

                    <li>
                        <strong>Regulatory Compliance:</strong>
                    </li>
                    <p>Employed for compliance and administrative functions.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.4 Special Categories of Health Information
                </h3>
                <h4 className="h4 fw-bold mt-3">Psychotherapy Notes</h4>
                <p>For mental health services:</p>
                <ul>
                    <li>
                        <strong>Separate Storage:</strong>
                    </li>
                    <p>
                        Psychotherapy notes are stored separately from the main
                        medical record.
                    </p>

                    <li>
                        <strong>Heightened Protection:</strong>
                    </li>
                    <p>Heightened protection and restricted access apply.</p>

                    <li>
                        <strong>Disclosure Authorization:</strong>
                    </li>
                    <p>Specific authorization is required for disclosure.</p>

                    <li>
                        <strong>Patient Rights:</strong>
                    </li>
                    <p>
                        Patients have the right to restrict certain disclosures.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    10.4.2 Substance Use Disorder Information
                </h3>
                <p>For substance use treatment:</p>
                <ul>
                    <li>
                        <strong>Regulatory Compliance:</strong>
                    </li>
                    <p>Compliance with 42 CFR Part 2 regulations.</p>

                    <li>
                        <strong>Disclosure Authorization:</strong>
                    </li>
                    <p>Additional authorization requirements for disclosure.</p>

                    <li>
                        <strong>Prohibition of Redisclosure:</strong>
                    </li>
                    <p>Prohibition of redisclosure without patient consent.</p>

                    <li>
                        <strong>Special Notice Requirements:</strong>
                    </li>
                    <p>
                        Special notice requirements for any permitted
                        disclosures.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">10.4.3 Genetic Information</h3>
                <p>For genetic testing and results:</p>
                <ul>
                    <li>
                        <strong>Regulatory Compliance:</strong>
                    </li>
                    <p>
                        Compliance with the Genetic Information
                        Nondiscrimination Act (GINA).
                    </p>

                    <li>
                        <strong>Enhanced Security:</strong>
                    </li>
                    <p>Enhanced security for genetic test results.</p>

                    <li>
                        <strong>Use and Disclosure Restrictions:</strong>
                    </li>
                    <p>Restrictions on certain uses and disclosures.</p>

                    <li>
                        <strong>Special Consent for Research:</strong>
                    </li>
                    <p>Special consent requirements for research use.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">10.4.4 HIV/AIDS Information</h3>
                <p>For HIV-related information:</p>
                <ul>
                    <li>
                        <strong>Regulatory Compliance:</strong>
                    </li>
                    <p>
                        Compliance with state-specific HIV confidentiality laws.
                    </p>

                    <li>
                        <strong>Heightened Protections:</strong>
                    </li>
                    <p>
                        Heightened protections for HIV status and test results.
                    </p>

                    <li>
                        <strong>Special Authorization:</strong>
                    </li>
                    <p>Special authorization requirements for disclosure.</p>

                    <li>
                        <strong>Staff Training:</strong>
                    </li>
                    <p>
                        Additional training for staff handling HIV information.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">Marketing Communications</h3>
                <h4 className="h4 fw-bold mb-2">Consent for Marketing</h4>
                <p>
                    We only send marketing communications with your explicit
                    consent:
                </p>
                <ul>
                    <li>
                        <strong>Opt-in Process:</strong>
                    </li>
                    <p>
                        Clear, affirmative action required to receive marketing.
                    </p>

                    <li>
                        <strong>Separate Consent:</strong>
                    </li>
                    <p>
                        Marketing consent obtained independently from service
                        consent.
                    </p>

                    <li>
                        <strong>Specific Channels:</strong>
                    </li>
                    <p>
                        Consent collected for each communication channel (email,
                        SMS, push notifications).
                    </p>

                    <li>
                        <strong>Granular Options:</strong>
                    </li>
                    <p>Ability to select types of marketing content.</p>

                    <li>
                        <strong>Record Keeping:</strong>
                    </li>
                    <p>Documentation of all marketing consent.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.1.2 Marketing Content</h3>
                <p>Our marketing communications may include:</p>
                <ul>
                    <li>
                        <strong>New Services and Features:</strong>
                    </li>
                    <p>Information about new services and features.</p>

                    <li>
                        <strong>Educational Content:</strong>
                    </li>
                    <p>
                        Educational content about health conditions and
                        treatments.
                    </p>

                    <li>
                        <strong>Event Invitations:</strong>
                    </li>
                    <p>Invitations to webinars and virtual events.</p>

                    <li>
                        <strong>Surveys and Feedback:</strong>
                    </li>
                    <p>Surveys and feedback requests.</p>

                    <li>
                        <strong>Special Offers:</strong>
                    </li>
                    <p>Special offers and promotions.</p>

                    <li>
                        <strong>Provider Spotlights:</strong>
                    </li>
                    <p>Provider spotlights and success stories.</p>

                    <li>
                        <strong>Newsletter Content:</strong>
                    </li>
                    <p>Newsletter content and health tips.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.1.3 Opting Out</h3>
                <p>
                    You can opt out of marketing communications at any time
                    through:
                </p>
                <ul>
                    <li>
                        <strong>Unsubscribe Links:</strong>
                    </li>
                    <p>Present in every marketing email.</p>

                    <li>
                        <strong>STOP Instructions:</strong>
                    </li>
                    <p>Text message opt-out directions.</p>

                    <li>
                        <strong>Preference Center:</strong>
                    </li>
                    <p>Self-service marketing preferences.</p>

                    <li>
                        <strong>Customer Support:</strong>
                    </li>
                    <p>Assistance with communication preferences.</p>

                    <li>
                        <strong>Do Not Call List:</strong>
                    </li>
                    <p>Compliance with telemarketing regulations.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    11.2 Service-Related Communications
                </h3>
                <p>
                    We send necessary service communications that are not
                    subject to marketing opt-out:
                </p>
                <ul>
                    <li>
                        <strong>Account Notifications:</strong>
                    </li>
                    <p>
                        Registration confirmation, password resets, and security
                        alerts.
                    </p>

                    <li>
                        <strong>Appointment Communications:</strong>
                    </li>
                    <p>Scheduling confirmations, reminders, and follow-ups.</p>

                    <li>
                        <strong>Medical Updates:</strong>
                    </li>
                    <p>Test results, treatment plans, and care instructions.</p>

                    <li>
                        <strong>Billing Notices:</strong>
                    </li>
                    <p>
                        Payment confirmation, insurance information, and
                        invoices.
                    </p>

                    <li>
                        <strong>Policy Changes:</strong>
                    </li>
                    <p>
                        Updates to Terms of Service, Privacy Policy, and other
                        agreements.
                    </p>

                    <li>
                        <strong>Legal Notices:</strong>
                    </li>
                    <p>
                        Required disclosures and important information about
                        your rights.
                    </p>

                    <li>
                        <strong>Service Announcements:</strong>
                    </li>
                    <p>Platform maintenance, outages, and critical updates.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.2.2 Delivery Channels</h3>
                <p>We use various channels for service communications:</p>
                <ul>
                    <li>
                        <strong>Email:</strong>
                    </li>
                    <p>
                        Primary method for detailed information and
                        documentation.
                    </p>

                    <li>
                        <strong>SMS/Text Messages:</strong>
                    </li>
                    <p>For time-sensitive notifications and reminders.</p>

                    <li>
                        <strong>Push Notifications:</strong>
                    </li>
                    <p>Mobile app alerts for important updates.</p>

                    <li>
                        <strong>In-App Messaging:</strong>
                    </li>
                    <p>Communications within the Platform interface.</p>

                    <li>
                        <strong>Secure Messaging:</strong>
                    </li>
                    <p>Encrypted channel for PHI and sensitive information.</p>

                    <li>
                        <strong>Phone Calls:</strong>
                    </li>
                    <p>For urgent matters requiring immediate attention.</p>

                    <li>
                        <strong>Mail:</strong>
                    </li>
                    <p>Physical documents when required by law or requested.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.2.3 Frequency and Timing</h3>
                <p>We are mindful of communication frequency:</p>
                <ul>
                    <li>
                        <strong>Critical Alerts:</strong>
                    </li>
                    <p>Sent immediately when necessary.</p>

                    <li>
                        <strong>Appointment Reminders:</strong>
                    </li>
                    <p>Sent at appropriate intervals.</p>

                    <li>
                        <strong>Batched Notifications:</strong>
                    </li>
                    <p>Where possible, to reduce volume.</p>

                    <li>
                        <strong>Time Zone Consideration:</strong>
                    </li>
                    <p>
                        Ensuring non-urgent communications respect user time
                        zones.
                    </p>

                    <li>
                        <strong>Customization Options:</strong>
                    </li>
                    <p>
                        Providing options to customize notification frequency
                        where appropriate.
                    </p>
                </ul>
                <h3 className="h3 fw-bold mb-2">
                    11.3 Emergency Communications
                </h3>
                <p>In medical emergencies:</p>
                <ul>
                    <li>
                        <strong>Urgent Alerts:</strong>
                    </li>
                    <p>Immediate notifications through multiple channels.</p>

                    <li>
                        <strong>Follow-up Instructions:</strong>
                    </li>
                    <p>Clear guidance on next steps.</p>

                    <li>
                        <strong>Emergency Services Integration:</strong>
                    </li>
                    <p>
                        Coordination with local emergency resources when
                        necessary.
                    </p>

                    <li>
                        <strong>Provider Notification:</strong>
                    </li>
                    <p>Automatic alerts to treating physicians.</p>

                    <li>
                        <strong>Designated Contact:</strong>
                    </li>
                    <p>
                        Communication with emergency contacts when authorized.
                    </p>

                    <li>
                        <strong>Documentation:</strong>
                    </li>
                    <p>Records of emergency communications and responses.</p>

                    <li>
                        <strong>Post-Emergency Follow-up:</strong>
                    </li>
                    <p>Communications after emergency resolution.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.3.2 Crisis Response</h3>
                <p>During platform-wide incidents or data breaches:</p>
                <ul>
                    <li>
                        <strong>Timely Notification:</strong>
                    </li>
                    <p>Prompt disclosure of relevant information.</p>

                    <li>
                        <strong>Impact Assessment:</strong>
                    </li>
                    <p>Clear explanation of potential effects.</p>

                    <li>
                        <strong>Mitigation Steps:</strong>
                    </li>
                    <p>Instructions for user actions to reduce risk.</p>

                    <li>
                        <strong>Support Resources:</strong>
                    </li>
                    <p>Additional assistance for affected users.</p>

                    <li>
                        <strong>Regular Updates:</strong>
                    </li>
                    <p>Ongoing communications until resolution.</p>

                    <li>
                        <strong>Regulatory Reporting:</strong>
                    </li>
                    <p>Parallel communication with authorities as required.</p>
                </ul>
                <h3 className="h3 fw-bold mb-2">11.4 Communication Security</h3>
                <h4 className="h4 fw-bold mt-3">Secure Messaging</h4>
                <p>For PHI and sensitive communications:</p>
                <ul>
                    <li>
                        <strong>End-to-End Encryption:</strong>
                    </li>
                    <p>Protection of message content.</p>

                    <li>
                        <strong>Secure Access:</strong>
                    </li>
                    <p>Authentication required to access messages.</p>

                    <li>
                        <strong>Auto-Timeout:</strong>
                    </li>
                    <p>Automatic session expiration for security.</p>

                    <li>
                        <strong>No Persistent Storage:</strong>
                    </li>
                    <p>Option for ephemeral messages that expire.</p>

                    <li>
                        <strong>Screen Protection:</strong>
                    </li>
                    <p>Prevention of screenshots where possible.</p>

                    <li>
                        <strong>Audit Trails:</strong>
                    </li>
                    <p>Records of message delivery and access.</p>

                    <li>
                        <strong>Data Loss Prevention:</strong>
                    </li>
                    <p>
                        Controls to prevent unauthorized forwarding or copying.
                    </p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    11.4.2 Communication Standards
                </h4>
                <p>All communications adhere to:</p>
                <ul>
                    <li>
                        <strong>Plain Language:</strong>
                    </li>
                    <p>Clear, understandable content without jargon.</p>

                    <li>
                        <strong>Accessibility:</strong>
                    </li>
                    <p>Compliance with web accessibility guidelines.</p>

                    <li>
                        <strong>Identifiable Source:</strong>
                    </li>
                    <p>Clear identification of SecOpp as the sender.</p>

                    <li>
                        <strong>Contact Information:</strong>
                    </li>
                    <p>Methods to reach us with questions.</p>

                    <li>
                        <strong>Privacy Respect:</strong>
                    </li>
                    <p>
                        No inclusion of sensitive information in unsecured
                        channels.
                    </p>

                    <li>
                        <strong>Regulatory Compliance:</strong>
                    </li>
                    <p>Adherence to healthcare communication requirements.</p>
                </ul>
                <h3 className="h3 fw-bold mt-4">CHILDREN’S PRIVACY</h3>
                <h4 className="h4 fw-bold mt-3">
                    Age Restrictions and Verification
                </h4>
                <h5 className="h5 fw-bold mt-2">Platform Age Limitations</h5>
                <ul>
                    <li>
                        Our Platform is not intended for use by children under
                        13 years of age.
                    </li>
                    <li>
                        Users between 13-18 years may access the Platform only
                        with parental/guardian involvement.
                    </li>
                    <li>
                        Special protections apply to all users under 18 years.
                    </li>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.1.2 Age Verification Methods
                </h4>
                <p>We employ multiple approaches to verify user age:</p>
                <ul>
                    <li>
                        <strong>Self-Declaration:</strong>
                    </li>
                    <p>Initial age verification during registration.</p>

                    <li>
                        <strong>Guardian Verification:</strong>
                    </li>
                    <p>Confirmation of parental/guardian authorization.</p>

                    <li>
                        <strong>Document Verification:</strong>
                    </li>
                    <p>
                        Where appropriate, verification of identification
                        documents.
                    </p>

                    <li>
                        <strong>Technical Measures:</strong>
                    </li>
                    <p>Implementation of age-gating technologies.</p>

                    <li>
                        <strong>Contextual Signals:</strong>
                    </li>
                    <p>Monitoring for indications of underage usage.</p>

                    <li>
                        <strong>Account Linking:</strong>
                    </li>
                    <p>
                        Connection of minor accounts to parent/guardian
                        accounts.
                    </p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.1.3 Action on Underage Access
                </h4>
                <p>
                    If we discover that personal information has been collected
                    from a child under 13 without parental consent:
                </p>
                <ul>
                    <li>
                        <strong>Immediate Suspension:</strong>
                    </li>
                    <p>We will immediately suspend the account.</p>

                    <li>
                        <strong>Data Deletion:</strong>
                    </li>
                    <p>Delete all collected personal information.</p>

                    <li>
                        <strong>Parental Notification:</strong>
                    </li>
                    <p>Provide notification to parents/guardians.</p>

                    <li>
                        <strong>Preventive Measures:</strong>
                    </li>
                    <p>
                        Implement additional safeguards for future prevention.
                    </p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.2 Parental Consent Mechanisms
                </h4>
                <p>
                    For users between 13-18 years, we obtain verifiable parental
                    consent through:
                </p>
                <ul>
                    <li>
                        <strong>Electronic Signature:</strong>
                    </li>
                    <p>Digital signature of consent forms.</p>

                    <li>
                        <strong>Credit Card Verification:</strong>
                    </li>
                    <p>Limited transaction to verify adult status.</p>

                    <li>
                        <strong>Video Verification:</strong>
                    </li>
                    <p>Real-time identity confirmation calls.</p>

                    <li>
                        <strong>Signed Consent Forms:</strong>
                    </li>
                    <p>Scanned and uploaded authorization documents.</p>

                    <li>
                        <strong>Knowledge-Based Questions:</strong>
                    </li>
                    <p>Questions only a parent/guardian would know.</p>

                    <li>
                        <strong>Two-Factor Verification:</strong>
                    </li>
                    <p>Multiple methods combined for higher assurance.</p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.2.2 Scope of Parental Consent
                </h4>
                <p>Parental consent includes authorization for:</p>
                <ul>
                    <li>
                        <strong>Collection and Use:</strong>
                    </li>
                    <p>
                        Collection and use of the minor’s personal information.
                    </p>

                    <li>
                        <strong>Account Management:</strong>
                    </li>
                    <p>Creation and management of the minor’s account.</p>

                    <li>
                        <strong>Healthcare Services:</strong>
                    </li>
                    <p>Telehealth consultations and healthcare services.</p>

                    <li>
                        <strong>Communication:</strong>
                    </li>
                    <p>Communication with the minor through the Platform.</p>

                    <li>
                        <strong>Data Storage:</strong>
                    </li>
                    <p>
                        Storage and processing of the minor’s health
                        information.
                    </p>

                    <li>
                        <strong>Healthcare Disclosure:</strong>
                    </li>
                    <p>
                        Disclosure to healthcare providers as needed for
                        treatment.
                    </p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.2.3 Parental Access and Control
                </h4>
                <p>Parents/guardians of minor users have:</p>
                <ul>
                    <li>
                        <strong>Access Rights:</strong>
                    </li>
                    <p>
                        Ability to review information collected from their
                        child.
                    </p>

                    <li>
                        <strong>Modification Rights:</strong>
                    </li>
                    <p>
                        Authority to request changes to their child’s
                        information.
                    </p>

                    <li>
                        <strong>Deletion Rights:</strong>
                    </li>
                    <p>Option to request deletion of their child’s data.</p>

                    <li>
                        <strong>Communication Control:</strong>
                    </li>
                    <p>Management of communications sent to their child.</p>

                    <li>
                        <strong>Consent Withdrawal:</strong>
                    </li>
                    <p>Right to revoke consent at any time.</p>

                    <li>
                        <strong>Activity Monitoring:</strong>
                    </li>
                    <p>Access to their child’s Platform usage history.</p>

                    <li>
                        <strong>Provider Selection:</strong>
                    </li>
                    <p>Approval of healthcare providers for consultations.</p>
                </ul>
                <h4 className="h4 fw-bold mt-3">
                    12.3 Special Protections for Minors’ Data
                </h4>
                <h5 className="h5 fw-bold mt-3">Data Minimization</h5>
                <p>For users under 18:</p>
                <ul>
                    <li>
                        <strong>Necessary Collection:</strong>
                    </li>
                    <p>
                        We collect only information that is reasonably
                        necessary.
                    </p>

                    <li>
                        <strong>Avoidance of Non-Essential Data:</strong>
                    </li>
                    <p>
                        We avoid collection of non-essential personal
                        information.
                    </p>

                    <li>
                        <strong>Automated Data Purging:</strong>
                    </li>
                    <p>
                        We implement automated purging of data when no longer
                        needed.
                    </p>

                    <li>
                        <strong>De-Identification:</strong>
                    </li>
                    <p>
                        We use de-identification where possible for analytical
                        purposes.
                    </p>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    12.3.2 Enhanced Security Measures
                </h5>
                <p>Additional protections include:</p>
                <ul>
                    <li>
                        <strong>Stricter Access Controls:</strong>
                    </li>
                    <p>Further limited access to minors’ data.</p>

                    <li>
                        <strong>Enhanced Encryption:</strong>
                    </li>
                    <p>Higher security standards for minors’ information.</p>

                    <li>
                        <strong>Special Handling Flags:</strong>
                    </li>
                    <p>System identifiers for minor accounts.</p>

                    <li>
                        <strong>Regular Auditing:</strong>
                    </li>
                    <p>More frequent review of access to minors’ records.</p>

                    <li>
                        <strong>Staff Training:</strong>
                    </li>
                    <p>
                        Specialized training for personnel handling minors’
                        data.
                    </p>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    12.3.3 Marketing and Advertising Restrictions
                </h5>
                <p>For minor users:</p>
                <ul>
                    <li>
                        <strong>No Targeted Advertising:</strong>
                    </li>
                    <p>Prohibition on behavioral advertising.</p>

                    <li>
                        <strong>No Data Sharing:</strong>
                    </li>
                    <p>No sharing with third parties for marketing.</p>

                    <li>
                        <strong>Age-Appropriate Content:</strong>
                    </li>
                    <p>Only suitable content and communications.</p>

                    <li>
                        <strong>No Profiling:</strong>
                    </li>
                    <p>No interest-based profile creation.</p>

                    <li>
                        <strong>No Incentives:</strong>
                    </li>
                    <p>
                        No rewards or gamification for providing additional
                        information.
                    </p>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    12.4 Jurisdiction-Specific Compliance
                </h5>
                <h6 className="h6 fw-bold mt-3">United States</h6>
                <p>Compliance with:</p>
                <ul>
                    <li>
                        <strong>
                            Children’s Online Privacy Protection Act (COPPA)
                        </strong>
                    </li>
                    <li>
                        <strong>
                            Family Educational Rights and Privacy Act (FERPA)
                        </strong>{" "}
                        where applicable
                    </li>
                    <li>
                        <strong>State-specific minor privacy laws</strong>
                    </li>
                    <li>
                        <strong>Minor consent to treatment laws</strong>
                    </li>
                </ul>
                <h6 className="h6 fw-bold mt-3">
                    International Considerations
                </h6>
                <ul>
                    <li>
                        <strong>GDPR provisions</strong> for children’s data
                        (for EU residents)
                    </li>
                    <li>
                        <strong>India’s data protection</strong> requirements
                        for minors
                    </li>
                    <li>
                        <strong>Other jurisdiction-specific protections</strong>
                    </li>
                </ul>
                <h6 className="h6 fw-bold mt-3">
                    Healthcare-Specific Regulations
                </h6>
                <ul>
                    <li>
                        <strong>HIPAA special provisions</strong> for minors
                    </li>
                    <li>
                        <strong>Mature minor doctrines</strong> where applicable
                    </li>
                    <li>
                        <strong>Sensitive service confidentiality</strong>{" "}
                        (reproductive health, mental health, substance use)
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">UPDATES TO PRIVACY POLICY</h5>
                <h6 className="h6 fw-bold mt-3">Policy Change Process</h6>
                <h6 className="h6 fw-bold mt-3">Reasons for Updates</h6>
                <p>
                    We may update this Privacy Policy for various reasons,
                    including:
                </p>
                <ul>
                    <li>
                        <strong>
                            Changes in our data practices or services
                        </strong>
                    </li>
                    <li>
                        <strong>
                            New features or technologies implemented
                        </strong>
                    </li>
                    <li>
                        <strong>
                            Regulatory and legal compliance requirements
                        </strong>
                    </li>
                    <li>
                        <strong>Industry best practice developments</strong>
                    </li>
                    <li>
                        <strong>Organizational changes</strong>
                    </li>
                    <li>
                        <strong>Security enhancement implementations</strong>
                    </li>
                    <li>
                        <strong>Clarifications based on user feedback</strong>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.1.2 Review and Approval Process
                </h5>
                <p>Our policy update process includes:</p>
                <ul>
                    <li>
                        <strong>Regular scheduled policy reviews</strong> (at
                        least annually)
                    </li>
                    <li>
                        <strong>Legal assessment of proposed changes</strong>
                    </li>
                    <li>
                        <strong>Privacy impact analysis</strong>
                    </li>
                    <li>
                        <strong>Stakeholder consultation</strong>
                    </li>
                    <li>
                        <strong>Executive approval</strong>
                    </li>
                    <li>
                        <strong>Documentation of changes</strong>
                    </li>
                    <li>
                        <strong>Version control and archiving</strong>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.1.3 Material vs. Non-Material Changes
                </h5>
                <p>We distinguish between:</p>
                <ul>
                    <li>
                        <strong>Material Changes</strong>: Significant
                        alterations to how we collect, use, or share personal
                        information
                    </li>
                    <li>
                        <strong>Non-Material Changes</strong>: Minor updates,
                        clarifications, or corrections that do not substantially
                        affect your rights or our practices
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">13.2 Notification Methods</h5>
                <p>
                    <strong>Communication Channels</strong>
                    <br />
                    We notify users of policy updates through:
                </p>
                <ul>
                    <li>
                        <strong>Email Notifications</strong>: Direct messages
                        for material changes
                    </li>
                    <li>
                        <strong>Platform Notices</strong>: Prominent banners or
                        pop-ups within the service
                    </li>
                    <li>
                        <strong>Website Announcements</strong>: Updates on our
                        homepage or privacy page
                    </li>
                    <li>
                        <strong>Mobile App Alerts</strong>: In-app notifications
                        where applicable
                    </li>
                    <li>
                        <strong>Blog Posts</strong>: Detailed explanations for
                        significant changes
                    </li>
                    <li>
                        <strong>Social Media Updates</strong>: Additional
                        notifications on official channels
                    </li>
                    <li>
                        <strong>API Notifications</strong>: For developers and
                        integration partners
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.2.2 Content of Notifications
                </h5>
                <p>
                    <strong>Our update notifications include:</strong>
                </p>
                <ul>
                    <li>
                        <strong>Summary of key changes</strong>
                    </li>
                    <li>
                        <strong>Effective date of the updated policy</strong>
                    </li>
                    <li>
                        <strong>
                            Access to both the current and updated versions
                        </strong>
                    </li>
                    <li>
                        <strong>Instructions for reviewing the changes</strong>
                    </li>
                    <li>
                        <strong>
                            Information about your options and rights
                        </strong>
                    </li>
                    <li>
                        <strong>
                            Contact details for questions or concerns
                        </strong>
                    </li>
                    <li>
                        <strong>Timeline for implementation</strong>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.2.3 Timing of Notifications
                </h5>
                <p>
                    <strong>We provide:</strong>
                </p>
                <ul>
                    <li>
                        <strong>Advance Notice:</strong> Typically at least 30
                        days before implementation of material changes
                    </li>
                    <li>
                        <strong>Immediate Notice:</strong> Prompt communication
                        for urgent security or compliance updates
                    </li>
                    <li>
                        <strong>Reminder Notifications:</strong> Follow-up
                        communication before implementation
                    </li>
                    <li>
                        <strong>Post-Implementation Confirmation:</strong>{" "}
                        Verification that changes are in effect
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.3 Implementation Timeline
                </h5>
                <p>
                    <strong>Grace Periods</strong>
                </p>
                <ul>
                    <li>
                        <strong>Minimum 30-day notice:</strong> before
                        implementation of material changes
                    </li>
                    <li>
                        <strong>Reasonable time:</strong> for users to review
                        and understand changes
                    </li>
                    <li>
                        <strong>Opportunity:</strong> to ask questions and seek
                        clarification
                    </li>
                    <li>
                        <strong>Staged rollout:</strong> for significant
                        platform changes
                    </li>
                    <li>
                        <strong>Extended timelines:</strong> for changes
                        affecting healthcare operations
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.3.2 User Response Options
                </h5>
                <p>During the notice period, users may:</p>
                <ul>
                    <li>
                        <strong>Continue using the service:</strong> under the
                        current policy until the effective date
                    </li>
                    <li>
                        <strong>Contact us:</strong> with questions or concerns
                        about the changes
                    </li>
                    <li>
                        <strong>Download a copy:</strong> of their data if
                        desired
                    </li>
                    <li>
                        <strong>Update their privacy preferences</strong>
                    </li>
                    <li>
                        <strong>Request account closure:</strong> if they do not
                        agree with the changes
                    </li>
                    <li>
                        <strong>Exercise applicable data rights:</strong>{" "}
                        (access, deletion, etc.)
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.3.3 Transition Assistance
                </h5>
                <p>For significant changes, we provide:</p>
                <ul>
                    <li>
                        <strong>FAQs:</strong> explaining the changes in plain
                        language
                    </li>
                    <li>
                        <strong>Support resources:</strong> to help understand
                        the impact
                    </li>
                    <li>
                        <strong>Instructions:</strong> for adjusting settings or
                        preferences
                    </li>
                    <li>
                        <strong>Direct assistance:</strong> through customer
                        support channels
                    </li>
                    <li>
                        <strong>Webinars or educational materials:</strong> for
                        major updates
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.4 Records and Documentation
                </h5>
                <p>Policy Archives</p>
                <ul>
                    <li>
                        <strong>Archives:</strong> of all previous policy
                        versions
                    </li>
                    <li>
                        <strong>Date ranges:</strong> when each version was in
                        effect
                    </li>
                    <li>
                        <strong>Change logs:</strong> documenting modifications
                    </li>
                    <li>
                        <strong>Records of notification:</strong> methods and
                        timing
                    </li>
                    <li>
                        <strong>User acknowledgment data:</strong> where
                        collected
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    13.4.2 Accessibility of Previous Versions
                </h5>
                <p>We make previous policy versions:</p>
                <ul>
                    <li>
                        <strong>Available:</strong> upon request
                    </li>
                    <li>
                        <strong>Accessible:</strong> through our privacy portal
                    </li>
                    <li>
                        <strong>Provided:</strong> in machine-readable formats
                        when possible
                    </li>
                    <li>
                        <strong>Formatted:</strong> for comparison with current
                        version
                    </li>
                    <li>
                        <strong>Preserved:</strong> with original formatting and
                        content
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">CONTACT INFORMATION</h5>
                <p>
                    <strong>Data Protection Officer</strong>
                </p>
                <p>
                    <strong>DPO Details</strong>
                </p>
                <ul>
                    <li>
                        <strong>Name:</strong> Purvi Shah
                    </li>
                    <li>
                        <strong>Title:</strong> Chief Privacy Officer, Second
                        Opinion USA LLC
                    </li>
                    <li>
                        <strong>Email:</strong> dpo@secopp.com
                    </li>
                    <li>
                        <strong>Office Address:</strong> 3748 Dover Dr,
                        Birmingham, AL – 35223
                    </li>
                    <li>
                        <strong>Office Hours:</strong> Monday to Friday, 9:00 AM
                        to 5:00 PM Eastern Time
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">14.1.2 DPO Responsibilities</h5>
                <p>Our Data Protection Officer is responsible for:</p>
                <ul>
                    <li>
                        <strong>Overseeing:</strong> data protection strategy
                        and implementation
                    </li>
                    <li>
                        <strong>Monitoring:</strong> compliance with privacy
                        regulations
                    </li>
                    <li>
                        <strong>Advising:</strong> on data protection impact
                        assessments
                    </li>
                    <li>
                        <strong>Serving:</strong> as the primary contact for
                        data subjects
                    </li>
                    <li>
                        <strong>Cooperating:</strong> with supervisory
                        authorities
                    </li>
                    <li>
                        <strong>Managing:</strong> the internal data protection
                        team
                    </li>
                    <li>
                        <strong>Conducting:</strong> privacy training and
                        awareness programs
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    14.1.3 When to Contact the DPO
                </h5>
                <p>You should contact our DPO directly for:</p>
                <ul>
                    <li>
                        <strong>Complex:</strong> privacy inquiries
                    </li>
                    <li>
                        <strong>Unresolved:</strong> privacy complaints
                    </li>
                    <li>
                        <strong>Data breach:</strong> notifications
                    </li>
                    <li>
                        <strong>Data protection impact:</strong> assessment
                        questions
                    </li>
                    <li>
                        <strong>Regulatory compliance:</strong> matters
                    </li>
                    <li>
                        <strong>Cross-border:</strong> data transfer issues
                    </li>
                    <li>
                        <strong>Privacy policy:</strong> interpretation
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">14.2 Privacy Team Contact</h5>
                <p>
                    <strong>General Privacy Inquiries</strong>
                    <br />
                    For general privacy questions or to exercise your rights:
                </p>
                <ul>
                    <li>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:privacy@secopp.com">
                            privacy@secopp.com
                        </a>
                    </li>
                    <li>
                        <strong>Online Form:</strong>{" "}
                        <a
                            href="https://www.secopp.com/privacy-request"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.secopp.com/privacy-request
                        </a>
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Postal Mail:</strong>
                        <br />
                        Privacy Team
                        <br />
                        Second Opinion USA LLC
                        <br />
                        3748 Dover Dr, Birmingham, AL – 35223
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">14.2.2 Response Timeframes</h5>
                <p>Our commitment to timely responses:</p>
                <ul>
                    <li>
                        <strong>Acknowledgment of requests:</strong> within 2
                        business days
                    </li>
                    <li>
                        <strong>Substantive responses:</strong> within 30
                        calendar days
                    </li>
                    <li>
                        <strong>Notification:</strong> if additional time is
                        needed
                    </li>
                    <li>
                        <strong>Regular status updates:</strong> for complex
                        requests
                    </li>
                    <li>
                        <strong>Expedited handling:</strong> for urgent matters
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    14.2.3 Specialized Contact Channels
                </h5>
                <p>For specific privacy matters:</p>
                <ul>
                    <li>
                        <strong>HIPAA Privacy Officer:</strong>{" "}
                        hipaa-privacy@secopp.com
                    </li>
                    <li>
                        <strong>Data Subject Requests:</strong> dsr@secopp.com
                    </li>
                    <li>
                        <strong>Security Concerns:</strong> security@secopp.com
                    </li>
                    <li>
                        <strong>Marketing Opt-Out:</strong>{" "}
                        unsubscribe@secopp.com
                    </li>
                    <li>
                        <strong>Children’s Privacy Questions:</strong>{" "}
                        minors-privacy@secopp.com
                    </li>
                    <li>
                        <strong>Accessibility Requests:</strong>{" "}
                        accessibility@secopp.com
                    </li>
                    <li>
                        <strong>Media Inquiries:</strong>{" "}
                        media-privacy@secopp.com
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    14.3 Regulatory Authority Contact
                </h5>
                <p>United States Authorities</p>
                <p>For unresolved concerns, you may contact:</p>
                <ul>
                    <li>
                        <strong>Federal Trade Commission (FTC):</strong>{" "}
                        <a
                            href="https://www.ftc.gov/complaint"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.ftc.gov/complaint
                        </a>
                    </li>
                    <li>
                        <strong>
                            U.S. Department of Health and Human Services (HHS):
                        </strong>{" "}
                        <a
                            href="https://www.hhs.gov/ocr/complaints/index.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.hhs.gov/ocr/complaints/index.html
                        </a>
                    </li>
                    <li>
                        <strong>State-specific Privacy Authorities:</strong>{" "}
                        Contact your state's Attorney General's office for
                        regional privacy issues
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    14.3 Regulatory Authority Contact
                </h5>
                <p>United States Authorities</p>
                <p>For unresolved concerns, you may contact:</p>
                <ul>
                    <li>
                        <strong>
                            U.S. Department of Health and Human Services (HHS) -
                            Office for Civil Rights:
                        </strong>
                        <p>
                            200 Independence Avenue, S.W. Washington, D.C. 20201
                        </p>
                        <p>
                            Toll-Free Call Center:{" "}
                            <a href="tel:1-800-368-1019">1-800-368-1019</a>
                        </p>
                        <p>
                            Website:{" "}
                            <a
                                href="https://www.hhs.gov/ocr/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.hhs.gov/ocr/privacy
                            </a>
                        </p>
                    </li>
                    <li>
                        <strong>Federal Trade Commission (FTC):</strong>
                        <p>600 Pennsylvania Avenue, NW Washington, DC 20580</p>
                        <p>
                            Toll-Free:{" "}
                            <a href="tel:1-877-382-4357">
                                1-877-FTC-HELP (1-877-382-4357)
                            </a>
                        </p>
                        <p>
                            Website:{" "}
                            <a
                                href="https://www.ftc.gov"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.ftc.gov
                            </a>
                        </p>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    14.3.2 California-Specific Authority
                </h5>
                <p>For California residents:</p>
                <h5 className="h5 fw-bold mt-3">
                    California Attorney General’s Office
                </h5>
                <p>For California residents:</p>
                <ul>
                    <li>
                        <strong>California Department of Justice Attn:</strong>{" "}
                        Office of Privacy Protection
                        <p>P.O. Box 944255, Sacramento, CA 94244-2550</p>
                        <p>
                            Toll-Free:{" "}
                            <a href="tel:1-800-952-5225">1-800-952-5225</a>
                        </p>
                        <p>
                            Website:{" "}
                            <a
                                href="https://oag.ca.gov/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                oag.ca.gov/privacy
                            </a>
                        </p>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">EU/EEA Authority</h5>
                <p>For EU/EEA residents (if applicable):</p>
                <ul>
                    <li>
                        <strong>European Data Protection Board</strong>
                        <p>
                            Website:{" "}
                            <a
                                href="https://edpb.europa.eu"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                edpb.europa.eu
                            </a>
                        </p>
                    </li>
                    <li>
                        <strong>
                            Local EU Member State Data Protection Authority:
                        </strong>
                        <p>
                            You may also contact your local EU member state’s
                            data protection authority for concerns.
                        </p>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">Indian Authority</h5>
                <p>For Indian residents:</p>
                <ul>
                    <li>
                        <strong>
                            Ministry of Electronics & Information Technology
                        </strong>
                        <p>
                            Electronics Niketan, 6, CGO Complex New Delhi –
                            110003
                        </p>
                        <p>
                            Website:{" "}
                            <a
                                href="https://www.meity.gov.in"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.meity.gov.in
                            </a>
                        </p>
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    Additional Contact Resources
                </h5>
                <p>Technical Support</p>
                <p>For Platform technical issues:</p>
                <ul>
                    <li>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:support@secopp.com">
                            support@secopp.com
                        </a>
                    </li>
                    <li>
                        <strong>Hours:</strong> Monday to Friday, 8:00 AM to
                        8:00 PM Eastern Time
                    </li>
                    <li>
                        <strong>Live Chat:</strong> Available through our
                        website and mobile app
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    Billing and Account Inquiries
                </h5>
                <p>For account and payment questions:</p>
                <ul>
                    <li>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:billing@secopp.com">
                            billing@secopp.com
                        </a>
                    </li>
                    <li>
                        <strong>Hours:</strong> Monday to Friday, 8:00 AM to
                        8:00 PM Eastern Time
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">Healthcare Providers</h5>
                <p>For healthcare providers using our Platform:</p>
                <ul>
                    <li>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:providers@secopp.com">
                            providers@secopp.com
                        </a>
                    </li>
                    <li>
                        <strong>Hours:</strong> 24/7 provider support
                    </li>
                </ul>
                <h5 className="h5 fw-bold mt-3">
                    United States (HIPAA & HITECH)
                </h5>
                <h6 className="h6 fw-bold">HIPAA Privacy Rule Provisions</h6>
                <p>As a covered entity and business associate under HIPAA:</p>
                <ul>
                    <li>
                        <strong>We comply:</strong> with all applicable
                        provisions of the HIPAA Privacy Rule
                    </li>
                    <li>
                        <strong>We maintain:</strong> a separate Notice of
                        Privacy Practices as required
                    </li>
                    <li>
                        <strong>We implement:</strong> appropriate
                        administrative, technical, and physical safeguards
                    </li>
                    <li>
                        <strong>We conduct:</strong> regular risk assessments
                        and workforce training
                    </li>
                    <li>
                        <strong>We provide:</strong> patients with access to
                        their protected health information
                    </li>
                    <li>
                        <strong>We account:</strong> for disclosures of
                        protected health information when required
                    </li>
                    <li>
                        <strong>We report:</strong> breaches as mandated by the
                        Breach Notification Rule
                    </li>
                </ul>
                <h6 className="h6 fw-bold">HITECH Act Compliance</h6>
                <p>Under the HITECH Act:</p>
                <ul>
                    <li>
                        <strong>We implement:</strong> enhanced security
                        provisions for electronic protected health information
                    </li>
                    <li>
                        <strong>We adhere:</strong> to stricter breach
                        notification requirements
                    </li>
                    <li>
                        <strong>We comply:</strong> with business associate
                        agreement provisions
                    </li>
                    <li>
                        <strong>We respond:</strong> to requests for electronic
                        copies of health records
                    </li>
                    <li>
                        <strong>We honor:</strong> restrictions on certain
                        disclosures to health plans
                    </li>
                    <li>
                        <strong>We limit:</strong> marketing communications as
                        prescribed
                    </li>
                    <li>
                        <strong>We maintain:</strong> audit trails of electronic
                        health record access
                    </li>
                </ul>
                <h6 className="h6 fw-bold">
                    State-Specific Healthcare Privacy Laws
                </h6>
                <p>We also comply with:</p>
                <ul>
                    <li>
                        <strong>State medical privacy laws:</strong> that may be
                        more stringent than HIPAA
                    </li>
                    <li>
                        <strong>State data breach notification laws:</strong> in
                        accordance with local regulations
                    </li>
                    <li>
                        <strong>State-specific consent requirements:</strong>{" "}
                        for sensitive information
                    </li>
                    <li>
                        <strong>State laws:</strong> regarding minors’
                        healthcare privacy
                    </li>
                    <li>
                        <strong>
                            State telehealth and telemedicine regulations:
                        </strong>{" "}
                        ensuring compliance with regional rules
                    </li>
                    <li>
                        <strong>
                            State electronic prescription and health record
                            laws:
                        </strong>{" "}
                        adherence to state-level health record management
                    </li>
                </ul>
                <h6 className="h6 fw-bold">European Union (GDPR)</h6>
                <p>
                    For users who are residents of the European Economic Area
                    (EEA), United Kingdom, or Switzerland, we comply with the
                    General Data Protection Regulation (GDPR) and equivalent
                    laws:
                </p>
                <h6 className="h6 fw-bold">
                    15.2.1 Legal Basis for Processing
                </h6>
                <p>
                    We process personal data only when we have a lawful basis,
                    including:
                </p>
                <ul>
                    <li>
                        <strong>Your explicit consent:</strong> When you provide
                        us with clear, informed, and voluntary consent to
                        process your data.
                    </li>
                    <li>
                        <strong>Performance of a contract with you:</strong> To
                        fulfill our contractual obligations, such as providing
                        our services.
                    </li>
                    <li>
                        <strong>Compliance with a legal obligation:</strong> To
                        comply with applicable laws and regulations.
                    </li>
                    <li>
                        <strong>Protection of vital interests:</strong> When
                        necessary to protect your life or the life of another
                        individual.
                    </li>
                    <li>
                        <strong>
                            Performance of a task in the public interest:
                        </strong>{" "}
                        When processing is necessary for the performance of a
                        task carried out in the public interest or in the
                        exercise of official authority.
                    </li>
                    <li>
                        <strong>
                            Legitimate interests that are not overridden by your
                            rights:
                        </strong>{" "}
                        To pursue our legitimate business interests, such as
                        improving our services, unless your fundamental rights
                        and freedoms require protection.
                    </li>
                    <h6 className="h6 fw-bold">15.2.2 Enhanced Rights</h6>
                    <p>
                        In addition to the rights outlined elsewhere in this
                        policy, you have:
                    </p>
                    <ul>
                        <li>
                            <strong>Right to Data Portability:</strong> Receive
                            your data in a structured, commonly used, and
                            machine-readable format.
                        </li>
                        <li>
                            <strong>Right to Object to Processing:</strong>{" "}
                            Object to processing of your data based on
                            legitimate interests or public interest.
                        </li>
                        <li>
                            <strong>Right to Restrict Processing:</strong> Limit
                            how we use your data while your request is being
                            considered.
                        </li>
                        <li>
                            <strong>Right to Withdraw Consent:</strong> Revoke
                            previously given consent without affecting the
                            lawfulness of prior processing.
                        </li>
                        <li>
                            <strong>Right to Lodge a Complaint:</strong> File a
                            complaint with a supervisory authority if you
                            believe we have violated your rights.
                        </li>
                        <li>
                            <strong>
                                Rights Related to Automated Decision Making:
                            </strong>{" "}
                            Not be subject to decisions based solely on
                            automated processing that produce legal or similarly
                            significant effects.
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">
                        15.2.3 International Transfers
                    </h6>
                    <p>For transfers of personal data outside the EEA:</p>
                    <ul>
                        <li>
                            <strong>
                                We implement appropriate safeguards:
                            </strong>{" "}
                            Such as Standard Contractual Clauses (SCCs).
                        </li>
                        <li>
                            <strong>
                                We conduct transfer impact assessments:
                            </strong>{" "}
                            As required for cross-border data transfers.
                        </li>
                        <li>
                            <strong>
                                We provide additional protective measures:
                            </strong>{" "}
                            Where necessary to ensure data protection.
                        </li>
                        <li>
                            <strong>We obtain prior consent:</strong> For
                            certain transfers where required by applicable laws.
                        </li>
                        <li>
                            <strong>We comply with adequacy decisions:</strong>{" "}
                            Of the European Commission to ensure sufficient data
                            protection standards.
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">15.3 California (CCPA/CPRA)</h6>
                    <p>
                        For California residents, we comply with the California
                        Consumer Privacy Act (CCPA) as amended by the California
                        Privacy Rights Act (CPRA):
                    </p>
                    <h6 className="h6 fw-bold">
                        15.3.1 California Privacy Rights
                    </h6>
                    <p>
                        In addition to other rights, California residents have:
                    </p>
                    <ul>
                        <li>
                            <strong>Right to Know:</strong> Request disclosure
                            of categories and specific pieces of personal
                            information collected
                        </li>
                        <li>
                            <strong>Right to Delete:</strong> Request deletion
                            of personal information with certain exceptions
                        </li>
                        <li>
                            <strong>Right to Correct:</strong> Request
                            correction of inaccurate personal information
                        </li>
                        <li>
                            <strong>
                                Right to Opt-Out of Sale or Sharing:
                            </strong>{" "}
                            Direct businesses not to sell or share personal
                            information
                        </li>
                        <li>
                            <strong>
                                Right to Limit Use of Sensitive Personal
                                Information:
                            </strong>{" "}
                            Restrict use of sensitive personal information to
                            specified purposes
                        </li>
                        <li>
                            <strong>Right to Non-Discrimination:</strong> Not be
                            discriminated against for exercising CCPA rights
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">
                        15.3.2 California Privacy Disclosures
                    </h6>
                    <p>As required by California law, we provide:</p>
                    <ul>
                        <li>
                            <strong>
                                Categories of personal information collected:
                            </strong>{" "}
                            In the preceding 12 months
                        </li>
                        <li>
                            <strong>Categories of sources:</strong> From which
                            information is collected
                        </li>
                        <li>
                            <strong>Business or commercial purposes:</strong>{" "}
                            For collecting information
                        </li>
                        <li>
                            <strong>Categories of third parties:</strong> With
                            whom information is shared
                        </li>
                        <li>
                            <strong>
                                Categories of personal information sold or
                                disclosed:
                            </strong>{" "}
                            For business purposes
                        </li>
                        <li>
                            <strong>Retention periods:</strong> For each
                            category of personal information
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">
                        15.3.3 Do Not Sell or Share My Personal Information
                    </h6>
                    <p>
                        We provide clear and conspicuous methods to opt out of
                        the sale or sharing of personal information, including:
                    </p>
                    <ul>
                        <li>
                            <strong>
                                “Do Not Sell or Share My Personal Information”
                                link:
                            </strong>{" "}
                            On our homepage
                        </li>
                        <li>
                            <strong>
                                Process for submitting opt-out requests:
                            </strong>{" "}
                            Clearly outlined for users
                        </li>
                        <li>
                            <strong>
                                Honor of Global Privacy Control signals:
                            </strong>{" "}
                            Respect for user preferences
                        </li>
                        <li>
                            <strong>
                                Verification procedures for requests:
                            </strong>{" "}
                            To ensure legitimate opt-out requests
                        </li>
                        <li>
                            <strong>Retention of opt-out preferences:</strong>{" "}
                            To honor future requests
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">15.4 India</h6>
                    <p>India Data Protection Compliance</p>
                    <p>For our operations serving patients in India:</p>
                    <ul>
                        <li>
                            <strong>
                                We adhere to India’s evolving data protection
                                framework
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We comply with the Information Technology Act,
                                2000 (IT Act) and its amendments
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We follow the Information Technology (Reasonable
                                Security Practices and Procedures and Sensitive
                                Personal Data or Information) Rules, 2011
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We monitor and will comply with the Digital
                                Personal Data Protection Act when fully
                                implemented
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We adopt security practices prescribed by
                                relevant Indian regulatory authorities
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We maintain documentation demonstrating
                                compliance with Indian privacy requirements
                            </strong>
                        </li>
                    </ul>
                    <h6 className="h6 fw-bold">
                        15.4.2 Cross-Border Data Transfers from India
                    </h6>
                    <p>For personal data transferred from India:</p>
                    <ul>
                        <li>
                            <strong>
                                We implement appropriate safeguards for
                                cross-border data transfers
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We obtain explicit consent for transfers where
                                required
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We ensure that data transferred to the U.S.
                                maintains equivalent protection
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We comply with any data localization
                                requirements for certain categories of data
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We maintain transparency about where Indian
                                users’ data is processed
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We facilitate exercise of privacy rights
                                regardless of data location
                            </strong>
                        </li>
                        <li>
                            <strong>
                                We monitor regulatory developments affecting
                                cross-border transfers
                            </strong>
                        </li>
                    </ul>
                    <h5 className="h5 fw-bold mt-3">CONCLUSION</h5>
                    <p>
                        This Privacy Policy demonstrates Second Opinion USA
                        LLC’s commitment to protecting your personal information
                        and health data while providing high-quality
                        telemedicine services. We strive to be transparent about
                        our data practices and to empower you with meaningful
                        choices about your information.
                    </p>
                    <p>
                        By using our Platform, you acknowledge that you have
                        read and understand this Privacy Policy. If you have
                        questions or concerns about our privacy practices,
                        please contact us using the information provided in
                        Section 14.
                    </p>
                    <p className="text-center">
                        © 2025 Second Opinion USA LLC. All Rights Reserved.
                    </p>
                </ul>
            </div>
        </div>
    );
};

export default PrivacyPolicyq;
